import axios from "axios";
import { notify } from "components";

import fileDownload from "js-file-download";

// axios.defaults.baseURL = "http://localhost:4000"
// console.log(process.env.REACT_APP_BASE_URLs)
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;


////////////////////////// USERS - Action Creator //////////////////////////

export const login = (data) => {
  return {
    type: "LOGIN",
    payload: data,
  };
};

export const logout = () => {
  return {
    type: "LOGOUT",
    payload: null,
  };
};

export const accounts = (data) => {
  return {
    type: "ACCOUNTS",
    payload: data,
  };
};

export const accounts_contacts = (data) => {
  return {
    type: "ACCOUNTS_CONTACTS",
    payload: data,
  };
};

export const vendors = (data) => {
  return {
    type: "VENDORS",
    payload: data,
  };
};

export const vendors_contacts = (data) => {
  return {
    type: "VENDORS_CONTACTS",
    payload: data,
  };
};

export const payments = (data) => {
  return {
    type: "PAYMENTS",
    payload: data,
  };
};

export const invoices = (data) => {
  return {
    type: "INVOICES",
    payload: data,
  };
};

export const quotes = (data) => {
  return {
    type: "QUOTES",
    payload: data,
  };
};

export const products = (data) => {
  return {
    type: "PRODUCTS",
    payload: data,
  };
};

export const services = (data) => {
  return {
    type: "SERVICES",
    payload: data,
  };
};

export const expenses = (data) => {
  return {
    type: "EXPENSES",
    payload: data,
  };
};

export const employees = (data) => {
  return {
    type: "EMPLOYEES",
    payload: data,
  };
};

export const users = (data) => {
  return {
    type: "USERS",
    payload: data,
  };
};

export const changeOrg = (data) => {
  return {
    type: "CHANGEORG",
    payload: data,
  };
};

//////////////Login/////////////

export const loggingIn = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/user/login/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

export const loggingOut = (data) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/user/logout/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Response for logout:", response);
      if (response.status === 204) {
        // notify("You are successfully logged out.", "success");
        dispatch(logout());
      }
    } catch (err) {
      console.log("Error", err);
      dispatch(logout());
      window.location.href = "/";
      // notify("You are successfully logged out.", "success");
    }
  };
};

export const logoutAllUsers = async () => {
  try {
    const response = await axios.post('/user/logout-all-users/', {}, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (err) {
    console.log("Error logging out all users:", err);
    throw err;
  }
};

export const check_token_validity = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get("/user/check-token-validity/");
      if (response.status === 200) {
      } else {
        dispatch(logout());
      }
    } catch (err) {
      console.log("Error", err);
      dispatch(logout());
    }
  };
};

//////////////Accounts/////////////

// export const loadAllAccounts = async() => {
//   try {
//     const response = await axios.get("/accounts/account/");
//     console.log("Response", response);
//     return response.data;
//   } catch (err) {
//     console.log("Error", err);
//     return err;
//   }
// }

export const loadAccounts = async (page, searchValue, page_size, filters = {}) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!page_size) {
      page_size = 15;
    }
    let url = `accounts/account/?page=${page}&page_size=${page_size}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    // One `products` param per id - the API matches an account carrying any of them.
    (filters.products || []).forEach((productId) => {
      url += `&products=${productId}`;
    });
    ["account_type", "customer_type", "created_after", "created_before"].forEach((key) => {
      if (filters[key]) url += `&${key}=${encodeURIComponent(filters[key])}`;
    });
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllAccounts = async (searchValue) => {
  try {
    let url = `accounts/account/?page_size=10000`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const fetchAccount = async (id) => {
  try {
    const response = await axios.get(`/accounts/account/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const addAccounts = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/accounts/account/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const updateAccounts = async (current, id) => {
  try {
    const response = await axios.put(`/accounts/account/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// See updateLeadProducts - a PATCH of the m2m key alone, so editing labels in
// the accounts table cannot disturb the rest of the account.
export const updateAccountProducts = async (id, productIds) => {
  try {
    const response = await axios.patch(`/accounts/account/${id}/`, { products: productIds });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// Keeping a phone number as the account's WhatsApp number from the list. A
// PATCH of that one key, so it cannot disturb the rest of the account.
export const updateAccountWaNumber = async (id, waNumber) => {
  try {
    const response = await axios.patch(`/accounts/account/${id}/`, { wa_number: waNumber });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const deleteAccounts = async (id) => {
  try {
    const response = await axios.delete(`/accounts/account/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

//////////////Accounts Contacts/////////////

export const loadAccountsContacts = async () => {
  // return async (dispatch) => {
  try {
    const response = await axios.get(`accounts/clientcontact/`);
    console.log("Response", response);
    // dispatch(accounts(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const fetchAccountsContacts = async (id) => {
  try {
    const response = await axios.get(`/accounts/client/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const addAccountsContacts = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/accounts/client/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateAccountsContacts = async (id) => {
  try {
    const response = await axios.put(`/accounts/client/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const deleteAccountsContacts = async (id) => {
  try {
    const response = await axios.delete(`/accounts/client/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

//////////////Vendors/////////////

export const loadVendors = async (page, searchValue, page_size) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!page_size) {
      page_size = 15;
    }
    let url = `vendors/vendor/?page=${page}&page_size=${page_size}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllVendors = async (searchValue) => {
  try {
    let url = `vendors/vendor/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const fetchVendors = async (id) => {
  try {
    const response = await axios.get(`/vendors/vendor/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const addVendors = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/vendors/vendor/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateVendors = async (current, id) => {
  try {
    const response = await axios.put(`/vendors/vendor/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteVendors = async (id) => {
  try {
    const response = await axios.delete(`/vendors/vendor/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
  }
};

//////////////Vendors Contacts/////////////

export const loadVendorsContacts = async () => {
  // return async (dispatch) => {
  try {
    const response = await axios.get(`vendors/vendor/`);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const fetchVendorsContacts = async (id) => {
  try {
    const response = await axios.get(`/vendors/vendor/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const addVendorsContacts = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/vendors/vendor/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateVendorsContacts = async (id) => {
  try {
    const response = await axios.put(`/vendors/vendor/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const deleteVendorsContacts = async (id) => {
  try {
    const response = await axios.delete(`/vendors/vendor/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

//////////////Invoices/////////////

// `status` may be one value or an array (a list matches any of them).
// `extra`: { products: [ids], dueDateRange: [dayjs, dayjs] }.
export const loadInvoices = async (page, searchValue, dateRange, accountId, status, pageSize, currencyId, extra = {}) => {
  const organization = null;
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!pageSize) {
      pageSize = 100;
    }
    let url = `invoices/invoices/?page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (dateRange && dateRange[0] && dateRange[1]) {
      url += `&start_date=${dateRange[0].format('YYYY-MM-DD')}&end_date=${dateRange[1].format('YYYY-MM-DD')}`;
    }
    if (accountId) {
      url += `&account=${accountId}`;
    }
    [].concat(status || []).forEach((value) => {
      url += `&status=${value}`;
    });
    (extra.products || []).forEach((productId) => {
      url += `&product=${productId}`;
    });
    if (extra.dueDateRange && extra.dueDateRange[0] && extra.dueDateRange[1]) {
      url += `&due_start_date=${extra.dueDateRange[0].format('YYYY-MM-DD')}&due_end_date=${extra.dueDateRange[1].format('YYYY-MM-DD')}`;
    }
    if (currencyId) {
      url += `&currency=${currencyId}`;
    }
    if (organization) {
      url += `&organization=${organization}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllInvoices = async (searchValue, dateRange, accountId, status) => {
  const organization = null;
  try {
    let url = `invoices/invoices/?page_size=10000`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (dateRange && dateRange[0] && dateRange[1]) {
      url += `&start_date=${dateRange[0].format('YYYY-MM-DD')}&end_date=${dateRange[1].format('YYYY-MM-DD')}`;
    }
    if (accountId) {
      url += `&account=${accountId}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (organization) {
      url += `&organization=${organization}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadInvoiceStatuses = async () => {
  try {
    const response = await axios.get(`/invoices/invoice_status/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Unable to load Invoice Statuses");
  }
};

export const loadBankAccounts = async (org) => {
  try {
    const response = await axios.get(`/organization/org-bank-accounts/?organization_id=${org}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Unable to load Bank Accounts");
  }
}

export const loadInvoice = async (id) => {
  try {
    const response = await axios.get(`/invoices/invoices/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Invoice not loaded!", JSON.stringify(err.response.data));
    // return err;
  }
};

export const invoiceRender = async (id, msgTemplate) => {
  try {
    const response = await axios.post(
      `/invoices/invoices/${id}/render/?rand=${new Date().getTime()}`,
      { template: msgTemplate }
    );
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Invoice not loaded!", JSON.stringify(err.response.data));
    // return err;
  }
};

export const paymentReceiptRender = async (id, msgTemplate) => {
  try {
    const response = await axios.post(
      `/invoices/payments/${id}/render/?rand=${new Date().getTime()}`,
      { template: msgTemplate }
    );
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Receipt not loaded!", JSON.stringify(err.response.data));
  }
};

export const invoicePdf = async (id) => {
  try {
    const response = await axios.post(
      `/invoices/invoices/${id}/pdf/?rand=${new Date().getTime()}`,
      {},
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      fileDownload(response.data, "template.pdf");
    }
    // return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Invoice not loaded!", JSON.stringify(err.response.data));
    // return err;
  }
};

export const addInvoices = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/invoices/invoices/?rand=${new Date().getTime()}`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    notify("error", "Invoice not created!", JSON.stringify(err.response.data));
    // return err;
  }
};

// invoiceDate ('YYYY-MM-DD', optional): mint the number for that month instead
// of the current one, so a back-dated invoice keeps number and date in sync.
export const generateInvoiceNumber = async (organizationId, invoiceDate) => {
  try {
    const dateParam = invoiceDate ? `&invoice_date=${invoiceDate}` : "";
    const response = await axios.get(`/invoices/invoices/generate_invoice_number/?organization=${organizationId}${dateParam}`);
    console.log("Generated Invoice Number Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Unable to generate invoice number!", JSON.stringify(err.response.data));
    return null;
  }
};

export const updateInvoices = async (data, id) => {
  try {
    console.log("DATA: ", data);
    const response = await axios.put(`/invoices/invoices/${id}/?rand=${new Date().getTime()}`, data);
    console.log("Response", response);
    // notify("success", "Invoice saved successfully!", null);
    return response;
  } catch (err) {
    console.log("Error", err);
    // The caller checks response.status, which an axios error does not carry,
    // so hand back the server's response and let it report the real reason.
    notify("error", "Invoice not saved!", JSON.stringify(err.response?.data));
    return err.response;
  }
};

export const deleteInvoices = async (id) => {
  try {
    const response = await axios.delete(`/invoices/invoices/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
  }
};

export const generateInvoicePaymentLink = async (id) => {
  try {
    const response = await axios.post(`/invoices/invoices/${id}/generate_payment_link/`);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return null;
  }
};

export const confirmInvoiceManualPayment = async (id, action, notes, amount) => {
  try {
    const response = await axios.post(`/invoices/invoices/${id}/confirm_manual_payment/`, {
      action,
      notes,
      amount,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return null;
  }
};

export const addDocumentsToInvoice = async (id, doc_ids) => {
  try {
    const response = await axios.post(
      `/invoices/invoices/${id}/adddocsfromdocuments/`,
      { documents: doc_ids }
    );
    return response.data;
  } catch (err) {
    return false;
  }
};

export const removeDocumentFromInvoice = async (id, doc_id) => {
  try {
    const response = await axios.post(`/invoices/invoices/${id}/removeDoc/`, {
      documents: [doc_id],
    });
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

export const sendInvoice = async (id, data) => {
  try {
    const response = await axios.post(
      `/invoices/invoices/${id}/sendInvoice/`,
      data
    );
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    throw err;
  }
};

//////////////Payments/////////////

export const loadPayments = async (page, searchValue, organization) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `invoices/payments/?page=${page}&page_size=100&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (organization) {
      url += `&organization=${organization}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllPayments = async (searchValue, page = 1, pageSize = 50, paymentLink = null, dateRange = null, hasPaymentLink = null) => {
  try {
    let url = `invoices/payments/?page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (paymentLink) {
      url += `&payment_link=${encodeURIComponent(paymentLink)}`;
    }
    if (hasPaymentLink === true || hasPaymentLink === "true" || hasPaymentLink === false || hasPaymentLink === "false") {
      url += `&has_payment_link=${hasPaymentLink}`;
    }
    if (dateRange && dateRange[0] && dateRange[1]) {
      url += `&start_date=${dateRange[0].format('YYYY-MM-DD')}&end_date=${dateRange[1].format('YYYY-MM-DD')}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadPayment = async (id) => {
  try {
    const response = await axios.get(`/invoices/payments/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Invoice not loaded!", JSON.stringify(err.response.data));
    // return err;
  }
};

export const fetchPayments = async (id) => {
  try {
    const response = await axios.get(`/invoices/payments/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const addPayments = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/invoices/payments/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Payment save failed!", null);
    return undefined;
  }
};

export const updatePayments = async (data, id) => {
  try {
    console.log("DATA: ", data);
    const response = await axios.put(`/invoices/payments/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Payment not saved!", JSON.stringify(err.response.data));
    return err;
  }
};

export const deletePayments = async (id) => {
  try {
    const response = await axios.delete(`/payments/payment/${id}`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const update_payment_statuses = async () => {
  try {
    const response = await axios.post(`/payment/py/update_payment_statuses/`);
    console.log("Response", response);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    console.log("Error", err);
  }
};

//////////////Products/////////////

export const loadProducts = async (page, searchValue) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }

    let url = `/product/product/?page=${page}&page_size=100&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllProducts = async (searchValue) => {
  try {
    let url = `/product/product/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const fetchProducts = async (id) => {
  try {
    const response = await axios.get(`/product/product/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

// Turns a DRF error body ({field: ["msg"], detail: "msg"}) into a readable string.
const formatApiError = (err) => {
  const data = err?.response?.data;
  if (!data) return err?.message || "Something went wrong. Please try again.";
  if (typeof data === "string") return data;
  if (data.detail) return data.detail;
  return Object.entries(data)
    .map(([field, messages]) => {
      const text = Array.isArray(messages) ? messages.join(" ") : messages;
      return field === "non_field_errors" ? text : `${field}: ${text}`;
    })
    .join(" | ");
};

export const addProducts = async (data) => {
  try {
    const response = await axios.post(`/product/product/`, data);
    return { success: true, data: response.data };
  } catch (err) {
    console.log("Error", err);
    return { success: false, error: formatApiError(err) };
  }
};

export const updateProducts = async (current, id) => {
  try {
    const response = await axios.put(`/product/product/${id}/`, current);
    return { success: true, data: response.data };
  } catch (err) {
    console.log("Error", err);
    return { success: false, error: formatApiError(err) };
  }
};

export const deleteProducts = async (id) => {
  try {
    await axios.delete(`/product/product/${id}/`);
    return true;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

//////////////Services/////////////

export const loadServices = async (page, searchValue) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/product/service/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const fetchServices = async (id) => {
  try {
    const response = await axios.get(`/product/service/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

export const addServices = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/product/service/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateServices = async (current, id) => {
  try {
    const response = await axios.put(`/product/service/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteServices = async (id) => {
  try {
    const response = await axios.delete(`/product/service/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

//////////////Expenses/////////////

export const loadExpenses = async (page, searchValue) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/accounting/expense/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllExpenses = async (searchValue) => {
  try {
    let url = `/accounting/expense/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const fetchExpenses = async (id) => {
  try {
    const response = await axios.get(`/accounting/expense/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

export const addExpenses = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/accounting/expense/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateExpenses = async (current, id) => {
  try {
    const response = await axios.put(`/accounting/expense/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteExpenses = async (id) => {
  try {
    const response = await axios.delete(`/accounting/expense/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

//////////////Expense Categories/////////////

export const loadExpenseCategories = async (searchValue, page_size) => {
  try {
    if (!page_size) page_size = 1000;
    let url = `/accounting/expense-category/?page_size=${page_size}`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading expense categories:", err);
    return err;
  }
};

export const addExpenseCategory = async (data) => {
  try {
    const response = await axios.post(`/accounting/expense-category/`, data);
    notify("success", "Expense category created successfully!");
    return response.data;
  } catch (err) {
    console.log("Error adding expense category:", err);
    notify("error", err?.response?.data?.code?.[0] || "Failed to create expense category");
    throw err;
  }
};

export const updateExpenseCategory = async (data, id) => {
  try {
    const response = await axios.put(`/accounting/expense-category/${id}/`, data);
    notify("success", "Expense category updated successfully!");
    return response.data;
  } catch (err) {
    console.log("Error updating expense category:", err);
    notify("error", err?.response?.data?.code?.[0] || "Failed to update expense category");
    throw err;
  }
};

export const deleteExpenseCategory = async (id) => {
  try {
    const response = await axios.delete(`/accounting/expense-category/${id}/`);
    notify("success", "Expense category deleted successfully!");
    return response;
  } catch (err) {
    console.log("Error deleting expense category:", err);
    notify("error", "Failed to delete expense category");
    return err;
  }
};

export const seedDefaultExpenseCategories = async () => {
  try {
    const response = await axios.post(`/accounting/expense-category/seed-defaults/`);
    notify("success", response.data?.message || "Default categories created");
    return response;
  } catch (err) {
    console.log("Error seeding expense categories:", err);
    notify("error", "Failed to seed default categories");
    return err;
  }
};

//////////////Employees/////////////

export const loadEmployees = async (page, searchValue, pageSize = 100) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/employee/employees/?page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllEmployees = async (searchValue) => {
  try {
    let url = `/employee/employees/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const retrieveEmployee = async (id) => {
  try {
    const response = await axios.get(`/employee/employees/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

export const addEmployees = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/employee/employees/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateEmployees = async (current, id) => {
  try {
    const response = await axios.put(`/employee/employees/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const partialUpdateEmployee = async (data, id) => {
  try {
    const response = await axios.patch(`/employee/employees/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteEmployees = async (id) => {
  try {
    const response = await axios.delete(`/employee/employees/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

//////////////Contacts/////////////

export const loadWATemplates = async (page, searchValue) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/whatsapp_api/whatsapp-templates/?rand=${new Date().getTime()}`;
    // if (searchValue) {
    //   url += `&search=${encodeURIComponent(searchValue)}`;
    // }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const refreshWATemplates = async (page, searchValue) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/whatsapp_api/refresh-templates/`;
    if (searchValue) {
      url += `&search=${searchValue}&rand=${new Date().getTime()}`;
    } else {
      url += `?rand=${new Date().getTime()}`;
    }
    const response = await axios.post(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadContacts = async (page, searchValue, pageSize) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!pageSize) {
      pageSize = 100;
    }
    let url = `/contact/contacts/?page=${page}&page_size=${pageSize}&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllContacts = async (searchValue) => {
  try {
    let url = `/contact/contacts/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadWAContacts = async (page, searchValue) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/whatsapp_api/whatsapp-contacts/?page=${page}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    url += `&rand=${new Date().getTime()}`;
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadMessagesForContact = async (contact) => {
  try {
    // if(!page){
    //   page = 1;
    // }

    await axios.post(
      `/whatsapp_api/whatsapp-contacts/mark_read/`,
      { wa_number: contact }
    );

    let url = `/whatsapp_api/whatsapp-messages/?contact__wa_id=${contact}&rand=${new Date().getTime()}`;
    // if (searchValue) {
    //   url += `&search=${encodeURIComponent(searchValue)}`;
    // }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const sendMessage = async (contact, type, text) => {
  try {
    // if(!page){
    //   page = 1;
    // }
    let url = `/whatsapp_api/send-message/`;
    // if (searchValue) {
    //   url += `&search=${encodeURIComponent(searchValue)}`;
    // }
    console.log(contact);
    const response = await axios.post(url, {
      contact: contact,
      type: type,
      text: text,
    });
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const sendTemplateMessage = async (values) => {
  try {
    // if(!page){
    //   page = 1;
    // }
    let url = `/whatsapp_api/send-template-message/`;
    // if (searchValue) {
    //   url += `&search=${encodeURIComponent(searchValue)}`;
    // // }
    console.log(values);
    // console.log(values.template.split("##"))
    const response = await axios.post(url, {
      wa_numbers: values.wa_numbers,
      template_id: values.template,
    });
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// WhatsApp Business Numbers
export const loadBusinessNumbers = async () => {
  try {
    const response = await axios.get(`/whatsapp_api/business-numbers/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const createBusinessNumber = async (data) => {
  try {
    const response = await axios.post(`/whatsapp_api/business-numbers/`, data);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateBusinessNumber = async (id, data) => {
  try {
    const response = await axios.put(`/whatsapp_api/business-numbers/${id}/`, data);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteBusinessNumber = async (id) => {
  try {
    const response = await axios.delete(`/whatsapp_api/business-numbers/${id}/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const testBusinessNumberConnection = async (id) => {
  try {
    const response = await axios.post(`/whatsapp_api/business-numbers/${id}/test_connection/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const syncBusinessNumberTemplates = async (id) => {
  try {
    const response = await axios.post(`/whatsapp_api/business-numbers/${id}/sync_templates/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadWADashboardStats = async (businessNumberId) => {
  try {
    let url = `/whatsapp_api/dashboard-stats/`;
    if (businessNumberId) {
      url += `?business_number_id=${businessNumberId}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadWAConversations = async (businessNumberId, page, searchValue) => {
  try {
    if (!page) page = 1;
    let url = `/whatsapp_api/whatsapp-contacts/conversations/?business_number=${businessNumberId}&page=${page}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadWAMessagesForContact = async (contactWaId, businessNumberId) => {
  try {
    let url = `/whatsapp_api/whatsapp-messages/for_contact/?contact_wa_id=${contactWaId}&business_number_id=${businessNumberId}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const sendWAMessage = async (businessNumberId, contact, type, text) => {
  try {
    const response = await axios.post(`/whatsapp_api/send-message/`, {
      business_number_id: businessNumberId,
      contact: contact,
      type: type,
      text: text,
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const sendWATemplateMessage = async (businessNumberId, waNumbers, templateId) => {
  try {
    const response = await axios.post(`/whatsapp_api/send-template-message/`, {
      business_number_id: businessNumberId,
      wa_numbers: waNumbers,
      template_id: templateId,
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadWATemplatesForNumber = async (businessNumberId, page) => {
  try {
    if (!page) page = 1;
    let url = `/whatsapp_api/whatsapp-templates/?business_number=${businessNumberId}&page=${page}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const markWAContactRead = async (waNumber, businessNumberId) => {
  try {
    const response = await axios.post(`/whatsapp_api/whatsapp-contacts/mark_read/`, {
      wa_number: waNumber,
      business_number_id: businessNumberId,
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Every contact linked to one account (for the accounts list's expanded row).
export const loadAccountContacts = async (accountId) => {
  const response = await axios.get(`/contact/contacts/?account=${accountId}&page_size=500&rand=${new Date().getTime()}`);
  return response.data?.results || [];
};

export const retrieveContact = async (id) => {
  try {
    const response = await axios.get(`/contact/contacts/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

export const addContacts = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/contact/contacts/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return undefined;
  }
};

export const updateContacts = async (current, id) => {
  try {
    const response = await axios.put(`/contact/contacts/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteContacts = async (id) => {
  try {
    const response = await axios.delete(`/contact/contacts/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

////////////// Leads ///////////
export const loadLeads = async (page, searchValue, pageSize, filters = {}) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!pageSize) {
      pageSize = 100;
    }
    let url = `/lead/leads/?page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    // One `products` param per id - the API matches a lead carrying any of them.
    (filters.products || []).forEach((productId) => {
      url += `&products=${productId}`;
    });
    // And tags - a lead carrying any of them matches.
    (filters.tags || []).forEach((tagId) => {
      url += `&tags=${tagId}`;
    });
    // Same for statuses - a lead in any of them matches.
    (filters.status || []).forEach((status) => {
      url += `&status=${status}`;
    });
    // Channel of the latest activity: `last_activity_type` keeps leads whose
    // last touch was any of these, `last_activity_type_not` drops them.
    ["last_activity_type", "last_activity_type_not"].forEach((key) => {
      (filters[key] || []).forEach((type) => {
        url += `&${key}=${type}`;
      });
    });
    // Everything else is a single-valued query param; blanks are dropped so an
    // untouched filter never narrows the list.
    [
      "source", "assigned_to", "created_after", "created_before",
      "last_activity_after", "last_activity_before",
    ].forEach((key) => {
      if (filters[key]) url += `&${key}=${encodeURIComponent(filters[key])}`;
    });
    // Yes/no filters: `false` ("missing", "not failed") is a real value, so
    // only an unset one is dropped.
    [
      "last_activity_failed", "has_email", "has_phone", "has_whatsapp",
    ].forEach((key) => {
      if (typeof filters[key] === "boolean") url += `&${key}=${filters[key]}`;
    });
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const retrieveLead = async (id) => {
  try {
    const response = await axios.get(`/lead/leads/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

// Master of extra-field keys (e.g. instagram) for the lead form's key dropdown.
export const listLeadExtraFieldKeys = async () => {
  try {
    const response = await axios.get(`/lead/extra-field-keys/`);
    return Array.isArray(response.data) ? response.data : [];
  } catch (err) {
    console.log("Error", err);
    return [];
  }
};

export const addLeads = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/lead/leads/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return undefined;
  }
};

// Products are m2m, so a PATCH of just this key replaces the lead's labels and
// leaves every other field alone - which is what editing the cell in the leads
// table should do.
export const updateLeadProducts = async (id, productIds) => {
  try {
    const response = await axios.patch(`/lead/leads/${id}/`, { products: productIds });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// The list's "save as WhatsApp number" action - one key, same reasoning as
// updateLeadProducts.
export const updateLeadWaNumber = async (id, waNumber) => {
  try {
    const response = await axios.patch(`/lead/leads/${id}/`, { wa_number: waNumber });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// Tags are m2m like products: a PATCH of just this key replaces the lead's tags.
export const updateLeadTags = async (id, tagIds) => {
  try {
    const response = await axios.patch(`/lead/leads/${id}/`, { tags: tagIds });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// Adds tags to many leads at once (each lead keeps the tags it already has).
// Resolves to { added, leads: [{ id, tags, tags_detail }] }.
export const bulkAddLeadTags = async (leadIds, tagIds) => {
  const response = await axios.post(`/lead/leads/bulk_add_tags/`, {
    lead_ids: leadIds,
    tag_ids: tagIds,
  });
  return response.data;
};

// Removes the given tags from many leads at once (their other tags stay).
// Resolves to { removed, leads: [{ id, tags, tags_detail }] }.
export const bulkRemoveLeadTags = async (leadIds, tagIds) => {
  const response = await axios.post(`/lead/leads/bulk_remove_tags/`, {
    lead_ids: leadIds,
    tag_ids: tagIds,
  });
  return response.data;
};

// Lead tags - an unpaginated list, already in the user's chosen order.
export const listLeadTags = async () => {
  const response = await axios.get(`/lead/tags/`);
  return Array.isArray(response.data) ? response.data : [];
};

export const createLeadTag = async (data) => {
  const response = await axios.post(`/lead/tags/`, data);
  return response.data;
};

export const updateLeadTag = async (id, data) => {
  const response = await axios.patch(`/lead/tags/${id}/`, data);
  return response.data;
};

export const deleteLeadTag = async (id) => {
  await axios.delete(`/lead/tags/${id}/`);
};

// Saves a new order: `ids` is every tag id, first to last. Returns the list.
export const reorderLeadTags = async (ids) => {
  const response = await axios.post(`/lead/tags/reorder/`, { ids });
  return Array.isArray(response.data) ? response.data : [];
};

export const updateLeadStatus = async (id, status) => {
  try {
    const response = await axios.patch(`/lead/leads/${id}/`, { status });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const updateLeads = async (current, id) => {
  try {
    const response = await axios.put(`/lead/leads/${id}/`, current);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteLeads = async (id) => {
  try {
    const response = await axios.delete(`/lead/leads/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const removeDocumentFromLeads = async (id, doc_id) => {
  try {
    const response = await axios.post(`/lead/leads/${id}/removeAttachment/`, {
      documents: [doc_id],
    });
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

// Lead Activity
export const addLeadActivity = async (data) => {
  try {
    const response = await axios.post(`/lead/leadactivity/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return undefined;
  }
};

export const updateLeadActivity = async (current, id) => {
  try {
    const response = await axios.put(`/lead/leadactivity/${id}/`, current);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteLeadActivity = async (id) => {
  try {
    const response = await axios.delete(`/lead/leadactivity/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Lead Task
export const addLeadTask = async (data) => {
  try {
    const response = await axios.post(`/lead/leadtask/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    // Re-throw so the caller can map field errors back onto the form.
    throw err;
  }
};

export const updateLeadTask = async (current, id) => {
  try {
    const response = await axios.put(`/lead/leadtask/${id}/`, current);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    // Re-throw so the caller can map field errors back onto the form.
    throw err;
  }
};

export const deleteLeadTask = async (id) => {
  try {
    const response = await axios.delete(`/lead/leadtask/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const convertLeadToDeal = async (leadId, data) => {
  try {
    const response = await axios.post(`/lead/leads/${leadId}/convert_to_deal/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err.response || err;
  }
};

//////////////Users/////////////

export const loadUsers = async (page, searchValue) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/user/user/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllUsers = async (searchValue) => {
  try {
    let url = `/user/user/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const fetchUsers = async (id) => {
  try {
    const response = await axios.get(`/user/user/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Erro", err);
    return err;
  }
};

export const addUsers = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/user/user/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateUsers = async (current, id) => {
  try {
    const response = await axios.put(`/user/user/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteUsers = async (id) => {
  try {
    const response = await axios.delete(`/user/user/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadOrganizations = async (id) => {
  try {
    const response = await axios.get(`/organization/organization/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    notify("error", "Error is fetching organizations!", null);
    console.log(err);
    return false;
  }
};

export const loadDocuments = async (page, searchValue, page_size) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!page_size) {
      page_size = 15;
    }
    let url = `/document/document/?page=${page}&page_size=${page_size}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    return err;
  }
};

export const loadAllDocuments = async (searchValue) => {
  try {
    let url = `/document/document/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadDocument = async (id) => {
  try {
    const response = await axios.get(`/document/document/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    return err;
  }
};

export const updateDocument = async (current, id) => {
  try {
    const response = await axios.put(`/document/document/${id}/`, current);
    console.log("Response", response);
    notify("success", "Document Deleted Successfully!", null);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", err, null);
    return err;
  }
};

export const deleteDocument = async (id) => {
  try {
    const response = await axios.delete(`/document/document/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const signDocument = async (id, signatureData) => {
  try {
    const response = await axios.post(`/document/document/${id}/sign/`, signatureData);
    if (response.status === 200 || response.status === 201) {
      notify("success", "Document signed successfully!", null);
      return response.data;
    }
    return response.data;
  } catch (err) {
    console.log("Error signing document", err);
    notify("error", "Failed to sign document", null);
    throw err;
  }
};

export const getDocumentSigningStatus = async (id) => {
  try {
    const response = await axios.get(`/document/document/${id}/signing_status/`);
    return response.data;
  } catch (err) {
    console.log("Error getting signing status", err);
    throw err;
  }
};

// ============== Employee Document APIs ==============

export const uploadDocument = async (file, categoryId = null) => {
  try {
    const formData = new FormData();
    formData.append('document_file', file);
    if (categoryId) {
      formData.append('category_id', categoryId);
    }
    const response = await axios.post('/document/document/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (response.status === 200 || response.status === 201) {
      return response.data;
    }
  } catch (err) {
    console.log("Error uploading document", err);
    notify("error", "Failed to upload document", null);
    return null;
  }
};

export const getDocumentCategoryByCode = async (code) => {
  try {
    const response = await axios.get(`/master/document-categories/?search=${code}`);
    if (response && response.status === 200 && response.data) {
      const category = response.data.find(cat => cat.code === code);
      return category ? category.id : null;
    }
    return null;
  } catch (error) {
    console.error('Error fetching document category:', error);
    return null;
  }
};

export const loadEmployeeDocuments = async (employeeId, page = 1, pageSize = 100) => {
  try {
    let url = `/employee/employee-documents/?employee=${employeeId}&page=${page}&page_size=${pageSize}`;
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading employee documents", err);
    return null;
  }
};

export const createEmployeeDocument = async (data) => {
  try {
    const response = await axios.post('/employee/employee-documents/', data);
    if (response.status === 200 || response.status === 201) {
      notify("success", "Document uploaded successfully!", null);
      return response.data || true;
    }
    return null;
  } catch (err) {
    console.log("Error creating employee document", err);
    notify("error", "Failed to create employee document", null);
    return null;
  }
};

export const updateEmployeeDocument = async (id, data) => {
  try {
    const response = await axios.post(`/employee/employee-documents/`, data);
    if (response.status === 200 || response.status === 201) {
      notify("success", "Document updated successfully!", null);
      return response.data || true;
    }
    return null;
  } catch (err) {
    console.log("Error updating employee document", err);
    notify("error", "Failed to update employee document", null);
    return null;
  }
};

export const deleteEmployeeDocument = async (id) => {
  try {
    const response = await axios.delete(`/employee/employee-documents/${id}/`);
    if (response.status === 204 || response.status === 200) {
      notify("success", "Document deleted successfully!", null);
      return true;
    }
  } catch (err) {
    console.log("Error deleting employee document", err);
    notify("error", "Failed to delete employee document", null);
    return false;
  }
};

export const loadTaxRates = async () => {
  try {
    const response = await axios.get(`/invoices/taxrates/`);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (err) {
    console.error("Error loading tax rates:", err);
    return [];
  }
};

export const loadPaymentModes = async () => {
  try {
    const response = await axios.get(`/invoices/payment_modes/`);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (err) {
    return err;
  }
};

export const loadPaymentStatuses = async () => {
  try {
    const response = await axios.get(`/invoices/payment_status/`);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (err) {
    return err;
  }
};

export const loadPaymentTypes = async () => {
  try {
    const response = await axios.get(`/invoices/payment_types/`);
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }
  } catch (err) {
    return err;
  }
};

// The source (RBI reference rate or ExchangeRate-API) is the organization's
// exchange_rate_source setting, so the organization has to be sent.
export const fetchExchangeRate = async (fromCurrency, toCurrency = 'INR', organization) => {
  try {
    const response = await axios.get(`/invoices/exchange-rate/`, {
      params: {
        from_currency: fromCurrency,
        to_currency: toCurrency,
        organization: organization || process.env.REACT_APP_ORGANIZATION_UUID || undefined,
      }
    });
    return response.data;
  } catch (err) {
    console.log("Error fetching exchange rate:", err);
    return { rate: null, success: false, error: 'Failed to fetch exchange rate' };
  }
};

//////////////Quotes/////////////

// `status` may be one value or an array (a list matches any of them).
// `extra`: { products: [ids], expiryDateRange: [dayjs, dayjs] }.
export const loadQuotes = async (page, searchValue, organization, dateRange, accountId, status, pageSize, extra = {}) => {
  // return async (dispatch) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!pageSize) {
      pageSize = 100;
    }
    let url = `quotes/quotes/?page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (dateRange && dateRange[0] && dateRange[1]) {
      url += `&start_date=${dateRange[0].format('YYYY-MM-DD')}&end_date=${dateRange[1].format('YYYY-MM-DD')}`;
    }
    if (accountId) {
      url += `&account=${accountId}`;
    }
    [].concat(status || []).forEach((value) => {
      url += `&status=${value}`;
    });
    (extra.products || []).forEach((productId) => {
      url += `&product=${productId}`;
    });
    if (extra.expiryDateRange && extra.expiryDateRange[0] && extra.expiryDateRange[1]) {
      url += `&expiry_start_date=${extra.expiryDateRange[0].format('YYYY-MM-DD')}&expiry_end_date=${extra.expiryDateRange[1].format('YYYY-MM-DD')}`;
    }
    if (organization) {
      url += `&organization=${organization}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    // dispatch(vendors(response.data));
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
  // }
};

export const loadAllQuotes = async (searchValue, dateRange, accountId, status) => {
  const organization = null;
  try {
    let url = `quotes/quotes/?page_size=10000&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (dateRange && dateRange[0] && dateRange[1]) {
      url += `&start_date=${dateRange[0].format('YYYY-MM-DD')}&end_date=${dateRange[1].format('YYYY-MM-DD')}`;
    }
    if (accountId) {
      url += `&account=${accountId}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (organization) {
      url += `&organization=${organization}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadQuoteStatuses = async () => {
  try {
    const response = await axios.get(`/quotes/quote_status/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Unable to load Quote Statuses");
  }
};

export const loadDeliveryTimelineUnits = async () => {
  try {
    const response = await axios.get(`/quotes/delivery_timeline_unit/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Unable to load Quote Statuses");
  }
};

export const loadQuote = async (id) => {
  try {
    const response = await axios.get(`/quotes/quotes/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Quote not loaded!", JSON.stringify(err.response.data));
    // return err;
  }
};

export const quoteRender = async (id, msgTemplate) => {
  try {
    const response = await axios.post(
      `/quotes/quotes/${id}/render/?rand=${new Date().getTime()}`,
      { template: msgTemplate }
    );
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Quote not loaded!", JSON.stringify(err.response.data));
    // return err;
  }
};

export const downloadQuote = async (id, is_preview, unique_name) => {
  try {
    const data = {
      is_preview,
      unique_name,
    };
    const response = await axios.post(
      `/quotes/quotes/${id}/quoteDownload/`,
      data,
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  } catch (err) {
    console.log("Error: ", err);
    return undefined;
  }
};

export const cloneQuote = async (id) => {
  try {
    // Make a POST request to the duplicate quote endpoint
    const response = await axios.post(`/quotes/quotes/${id}/clone/`);

    if (response.status === 201) {
      console.log("Clone successful", response.data);
      return response.data;  // Return the duplicated quote data
    }
    return false;
  } catch (err) {
    console.error("Error cloning the quote: ", err);
    return false;
  }
};

export const convertQuoteToInvoice = async (quoteId, data = {}) => {
  try {
    const response = await axios.post(`/quotes/quotes/${quoteId}/convert_to_invoice/`, data);
    if (response.status === 201) {
      console.log("Quote converted to invoice successfully", response.data);
      return response.data;  // Return the new invoice data
    }
    return undefined;
  } catch (err) {
    console.error("Error converting quote to invoice:", err);
    notify("error", "Failed to convert quote to invoice");
    return undefined;
  }
};

export const addQuotes = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/quotes/quotes/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    notify("error", "Quote not created!", JSON.stringify(err.response?.data));
    // return err;
  }
};

export const generateQuoteNumber = async (organizationId) => {
  try {
    const response = await axios.get(`/quotes/quotes/generate_quote_number/?organization=${organizationId}`);
    console.log("Generated Quote Number Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Unable to generate quote number!", JSON.stringify(err.response?.data));
    return null;
  }
};

export const updateQuotes = async (data, id) => {
  try {
    console.log("DATA: ", data);
    const response = await axios.put(`/quotes/quotes/${id}/`, data);
    console.log("Response", response);
    // notify("success", "Quote saved successfully!", null);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    // Returning the error here would read as a success to the caller, which is
    // how a failed save used to be reported as "Quote updated successfully!".
    notify("error", "Quote not saved!", JSON.stringify(err.response?.data));
    return undefined;
  }
};

export const deleteQuotes = async (id) => {
  try {
    const response = await axios.delete(`/quotes/quotes/${id}/`);
    console.log("Response", response);
  } catch (err) {
    console.log("Error", err);
  }
};

export const addDocumentsToQuote = async (id, doc_ids) => {
  try {
    const response = await axios.post(
      `/quotes/quotes/${id}/adddocsfromdocuments/`,
      { documents: doc_ids }
    );
    return response.data;
  } catch (err) {
    return false;
  }
};

export const removeDocumentFromQuote = async (id, doc_id) => {
  try {
    const response = await axios.post(`/quotes/quotes/${id}/removeDoc/`, {
      documents: [doc_id],
    });
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

export const sendQuote = async (id, data) => {
  try {
    const response = await axios.post(`/quotes/quotes/${id}/sendQuote/`, data);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    throw err;
  }
};

export const addDocumentsToEmployee = async (id, doc_ids) => {
  try {
    const response = await axios.post(
      `/user/employee/${id}/adddocsfromdocuments/`,
      { documents: doc_ids }
    );
    return response.data;
  } catch (err) {
    return false;
  }
};

export const removeDocumentFromEmployee = async (id, doc_id) => {
  try {
    const response = await axios.post(`/user/employee/${id}/removeDoc/`, {
      documents: [doc_id],
    });
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

// New Employee-related API functions
export const loadEmployeesByOrganization = async (organizationId, page = 1, searchValue, pageSize = 100) => {
  try {
    let url = `/employee/employees/by_organization/?organization_id=${organizationId}&page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const loadEmployeeAddresses = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/employees/${employeeId}/addresses/`);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const loadEmployeeEducation = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/employees/${employeeId}/education/`);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const loadEmployeeExperience = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/employees/${employeeId}/experience/`);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const loadEmployeeSalaryHistory = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/employees/${employeeId}/salary_history/`);
    return response.data;
  } catch (err) {
    return err;
  }
};

// Address CRUD operations
export const addEmployeeAddress = async (data) => {
  try {
    const response = await axios.post(`/employee/addresses/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateEmployeeAddress = async (id, data) => {
  try {
    const response = await axios.put(`/employee/addresses/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteEmployeeAddress = async (id) => {
  try {
    const response = await axios.delete(`/employee/addresses/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Education CRUD operations
export const addEmployeeEducation = async (data) => {
  try {
    const response = await axios.post(`/employee/education/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateEmployeeEducation = async (id, data) => {
  try {
    const response = await axios.put(`/employee/education/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteEmployeeEducation = async (id) => {
  try {
    const response = await axios.delete(`/employee/education/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Experience CRUD operations
export const addEmployeeExperience = async (data) => {
  try {
    const response = await axios.post(`/employee/experience/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateEmployeeExperience = async (id, data) => {
  try {
    const response = await axios.put(`/employee/experience/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteEmployeeExperience = async (id) => {
  try {
    const response = await axios.delete(`/employee/experience/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Salary Revision CRUD operations
export const addSalaryRevision = async (data) => {
  try {
    const response = await axios.post(`/employee/salary-revisions/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateSalaryRevision = async (id, data) => {
  try {
    const response = await axios.put(`/employee/salary-revisions/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteSalaryRevision = async (id) => {
  try {
    const response = await axios.delete(`/employee/salary-revisions/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Emergency Contact CRUD operations
export const loadEmployeeEmergencyContacts = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/emergency-contacts/?employee=${employeeId}`);
    return response.data.results || response.data;
  } catch (err) {
    return err;
  }
};

export const addEmployeeEmergencyContact = async (data) => {
  try {
    const response = await axios.post(`/employee/emergency-contacts/`, data);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const updateEmployeeEmergencyContact = async (data, id) => {
  try {
    const response = await axios.put(`/employee/emergency-contacts/${id}/`, data);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const deleteEmployeeEmergencyContact = async (id) => {
  try {
    await axios.delete(`/employee/emergency-contacts/${id}/`);
    return true;
  } catch (err) {
    return err;
  }
};

export const toggleEmployeeProfileLock = async (employeeId, profileLocked) => {
  try {
    const response = await axios.patch(`/employee/employees/${employeeId}/toggle_profile_lock/`, {
      profile_locked: profileLocked
    });
    return response.data;
  } catch (err) {
    console.log("Error toggling profile lock:", err);
    return err;
  }
};

export const getCurrentUserEmployee = async () => {
  try {
    const response = await axios.get('/user/current-user-employee/');
    return response.data;
  } catch (err) {
    console.log("Error fetching current user employee:", err);
    return err;
  }
};

// Salary Management API functions

// Basic Salary
export const loadBasicSalaries = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/basic-salaries/?employee=${employeeId}`);
    return response.data;
  } catch (err) {
    console.log("Error loading basic salaries:", err);
    return err;
  }
};

export const getCurrentBasicSalary = async (employeeId) => {
  try {
    const response = await axios.get(`/employee/basic-salaries/current_salary/?employee=${employeeId}`);
    return response.data;
  } catch (err) {
    console.log("Error loading current basic salary:", err);
    return err;
  }
};

export const createBasicSalary = async (data) => {
  try {
    const response = await axios.post('/employee/basic-salaries/', data);
    return response.data;
  } catch (err) {
    console.log("Error creating basic salary:", err);
    return err;
  }
};

export const updateBasicSalary = async (id, data) => {
  try {
    const response = await axios.put(`/employee/basic-salaries/${id}/`, data);
    return response.data;
  } catch (err) {
    console.log("Error updating basic salary:", err);
    return err;
  }
};

export const deleteBasicSalary = async (id) => {
  try {
    await axios.delete(`/employee/basic-salaries/${id}/`);
    return true;
  } catch (err) {
    console.log("Error deleting basic salary:", err);
    return err;
  }
};

// Employee Allowances
export const loadAllowances = async (employeeId, monthYear = null) => {
  try {
    let url = `/employee/allowances/?employee=${employeeId}`;
    if (monthYear) {
      url += `&month_year=${monthYear}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error loading allowances:", err);
    return err;
  }
};

export const getAllowancesForMonth = async (employeeId, monthYear) => {
  try {
    const response = await axios.get(`/employee/allowances/for_month/?employee=${employeeId}&month_year=${monthYear}`);
    return response.data;
  } catch (err) {
    console.log("Error loading allowances for month:", err);
    return err;
  }
};

export const calculateAllowance = async (employeeId, calculationType, amount, effectiveDate = null) => {
  try {
    const data = {
      employee: employeeId,
      calculation_type: calculationType,
      amount: amount
    };
    if (effectiveDate) {
      data.effective_date = effectiveDate;
    }
    const response = await axios.post('/employee/allowances/calculate_allowance/', data);
    return response.data;
  } catch (err) {
    console.log("Error calculating allowance:", err);
    return err;
  }
};

export const createAllowance = async (data) => {
  try {
    const response = await axios.post('/employee/allowances/', data);
    return response.data;
  } catch (err) {
    console.log("Error creating allowance:", err);
    return err;
  }
};

export const updateAllowance = async (id, data) => {
  try {
    const response = await axios.put(`/employee/allowances/${id}/`, data);
    return response.data;
  } catch (err) {
    console.log("Error updating allowance:", err);
    return err;
  }
};

export const deleteAllowance = async (id) => {
  try {
    await axios.delete(`/employee/allowances/${id}/`);
    return true;
  } catch (err) {
    console.log("Error deleting allowance:", err);
    return err;
  }
};

// Employee Commissions
export const loadCommissions = async (employeeId, monthYear = null) => {
  try {
    let url = `/employee/commissions/?employee=${employeeId}`;
    if (monthYear) {
      url += `&month_year=${monthYear}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error loading commissions:", err);
    return err;
  }
};

export const getCommissionsForMonth = async (employeeId, monthYear) => {
  try {
    const response = await axios.get(`/employee/commissions/for_month/?employee=${employeeId}&month_year=${monthYear}`);
    return response.data;
  } catch (err) {
    console.log("Error loading commissions for month:", err);
    return err;
  }
};

export const createCommission = async (data) => {
  try {
    const response = await axios.post('/employee/commissions/', data);
    return response.data;
  } catch (err) {
    console.log("Error creating commission:", err);
    return err;
  }
};

export const updateCommission = async (id, data) => {
  try {
    const response = await axios.put(`/employee/commissions/${id}/`, data);
    return response.data;
  } catch (err) {
    console.log("Error updating commission:", err);
    return err;
  }
};

export const deleteCommission = async (id) => {
  try {
    await axios.delete(`/employee/commissions/${id}/`);
    return true;
  } catch (err) {
    console.log("Error deleting commission:", err);
    return err;
  }
};

// Employee Other Payments
export const loadOtherPayments = async (employeeId, monthYear = null) => {
  try {
    let url = `/employee/other-payments/?employee=${employeeId}`;
    if (monthYear) {
      url += `&month_year=${monthYear}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error loading other payments:", err);
    return err;
  }
};

export const getOtherPaymentsForMonth = async (employeeId, monthYear) => {
  try {
    const response = await axios.get(`/employee/other-payments/for_month/?employee=${employeeId}&month_year=${monthYear}`);
    return response.data;
  } catch (err) {
    console.log("Error loading other payments for month:", err);
    return err;
  }
};

export const createOtherPayment = async (data) => {
  try {
    const response = await axios.post('/employee/other-payments/', data);
    return response.data;
  } catch (err) {
    console.log("Error creating other payment:", err);
    return err;
  }
};

export const updateOtherPayment = async (id, data) => {
  try {
    const response = await axios.put(`/employee/other-payments/${id}/`, data);
    return response.data;
  } catch (err) {
    console.log("Error updating other payment:", err);
    return err;
  }
};

export const deleteOtherPayment = async (id) => {
  try {
    await axios.delete(`/employee/other-payments/${id}/`);
    return true;
  } catch (err) {
    console.log("Error deleting other payment:", err);
    return err;
  }
};

// Employee Statutory Deductions
export const loadDeductions = async (employeeId, monthYear = null) => {
  try {
    let url = `/employee/deductions/?employee=${employeeId}`;
    if (monthYear) {
      url += `&month_year=${monthYear}`;
    }
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error loading deductions:", err);
    return err;
  }
};

export const getDeductionsForMonth = async (employeeId, monthYear) => {
  try {
    const response = await axios.get(`/employee/deductions/for_month/?employee=${employeeId}&month_year=${monthYear}`);
    return response.data;
  } catch (err) {
    console.log("Error loading deductions for month:", err);
    return err;
  }
};

export const createDeduction = async (data) => {
  try {
    const response = await axios.post('/employee/deductions/', data);
    return response.data;
  } catch (err) {
    console.log("Error creating deduction:", err);
    return err;
  }
};

export const updateDeduction = async (id, data) => {
  try {
    const response = await axios.put(`/employee/deductions/${id}/`, data);
    return response.data;
  } catch (err) {
    console.log("Error updating deduction:", err);
    return err;
  }
};

export const deleteDeduction = async (id) => {
  try {
    await axios.delete(`/employee/deductions/${id}/`);
    return true;
  } catch (err) {
    console.log("Error deleting deduction:", err);
    return err;
  }
};

// Master Type API functions
export const fetchAllowanceTypes = async () => {
  try {
    const response = await axios.get('/masters/allowance-types/');
    return response.data;
  } catch (err) {
    console.log("Error fetching allowance types:", err);
    return err;
  }
};

export const fetchDeductionTypes = async () => {
  try {
    const response = await axios.get('/masters/deduction-types/');
    return response.data;
  } catch (err) {
    console.log("Error fetching deduction types:", err);
    return err;
  }
};

export const fetchPaymentTypes = async () => {
  try {
    const response = await axios.get('/masters/payment-types/');
    return response.data;
  } catch (err) {
    console.log("Error fetching payment types:", err);
    return err;
  }
};

// OTP and Authentication API functions
export const requestLoginOTP = async (email) => {
  try {
    const response = await axios.post('/user/login-otp/', { email });
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const verifyLoginOTP = async (email, otp_code) => {
  try {
    const response = await axios.post('/user/verify-login-otp/', {
      email,
      otp_code,
      otp_type: 'login'
    });
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const verifyPasswordResetOTP = async (email, otp_code) => {
  try {
    const response = await axios.post('/user/verify-password-reset-otp/', {
      email,
      otp_code,
      otp_type: 'password_reset'
    });
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const requestPasswordReset = async (email) => {
  try {
    const response = await axios.post('/user/password-reset-request/', { email });
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const confirmPasswordReset = async (email, otp_code, new_password, confirm_password) => {
  try {
    const response = await axios.post('/user/password-reset-confirm/', {
      email,
      otp_code,
      new_password,
      confirm_password
    });
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const setUserPassword = async (password, confirm_password, user_id) => {
  try {
    const payload = { password, confirm_password };
    if (user_id) {
      payload.user_id = user_id;
    }
    const response = await axios.post('/user/set-password/', payload);
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const resendOTP = async (email, otp_type = 'login') => {
  try {
    const response = await axios.post('/user/resend-otp/', {
      email,
      otp_type
    });
    return response.data;
  } catch (err) {
    return err.response?.data || err;
  }
};

export const downloadInvoice = async (id, is_preview, unique_name) => {
  try {
    const data = {
      is_preview,
      unique_name,
    };
    const response = await axios.post(
      `/invoices/invoices/${id}/invoiceDownload/`,
      data,
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      return response.data;
    }
    return undefined;
  } catch (err) {
    console.log("Error: ", err);
    return undefined;
  }
};

export const cloneInvoice = async (id) => {
  try {
    // Make a POST request to the duplicate quote endpoint
    const response = await axios.post(`/invoices/invoices/${id}/clone/`);

    if (response.status === 201) {
      console.log("Clone successful", response.data);
      return response.data;  // Return the duplicated quote data
    }
    return false;
  } catch (err) {
    console.error("Error cloning the invoice: ", err);
    return false;
  }
};

export const createQuoteFromInvoice = async (invoiceId) => {
  try {
    const response = await axios.post(`/invoices/invoices/${invoiceId}/create_quote/`);
    if (response.status === 201) {
      return response.data;
    }
    return undefined;
  } catch (err) {
    console.error("Error creating quote from invoice:", err);
    return undefined;
  }
};

// Asset files //

export const loadAssetFiles = async (page, searchValue) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/assetfile/assetfile/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response;
    }
  } catch (err) {
    return err;
  }
};

export const loadAssetFile = async (id) => {
  try {
    const response = await axios.get(`/assetfile/assetfile/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    return err;
  }
};

export const updateAssetFile = async (current, id) => {
  try {
    const response = await axios.put(`/assetfile/assetfile/${id}/`, current);
    console.log("Response", response);
    notify("success", "AssetFile Deleted Successfully!", null);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", err, null);
    return err;
  }
};

export const deleteAssetFile = async (id) => {
  try {
    const response = await axios.delete(`/assetfile/assetfile/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

//////////////////////// System Monitoring /////////////////////////////

export const loadAllMonitors = async (page, searchValue) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/uptime/monitors/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    return err;
  }
};

export const loadMonitoringStats = async () => {
  try {
    const response = await axios.get(`/uptime/monitoring_stats/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    return err;
  }
};

export const fetchMonitor = async (id) => {
  try {
    const response = await axios.get(`/uptime/monitors/${id}/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const addMonitor = async (data) => {
  try {
    console.log(data);
    const response = await axios.post(`/uptime/monitors/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const updateMonitor = async (current, id) => {
  try {
    const response = await axios.put(`/uptime/monitors/${id}/`, current);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const pauseMonitor = async (id) => {
  try {
    const response = await axios.get(`/uptime/monitors/${id}/pause/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteMonitor = async (id) => {
  try {
    const response = await axios.delete(`/uptime/monitors/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

/////////////////////////Dashboard/////////////////////////////

export const fetchDashboardData = async () => {
  try {
    const response = await axios.post(`/dashboard/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// Dashboard Analytics Functions
export const fetchSalesAnalytics = async (filterPreset = 'this_month') => {
  try {
    const response = await axios.get(`/product/product/sales-analytics/`, {
      params: { filter_preset: filterPreset }
    });
    return response.data;
  } catch (err) {
    console.log("Error fetching sales analytics", err);
    throw err;
  }
};

export const fetchPipelineAnalytics = async (filterPreset = 'this_month') => {
  try {
    const response = await axios.get(`/deal/deals/pipeline-analytics/`, {
      params: { filter_preset: filterPreset }
    });
    return response.data;
  } catch (err) {
    console.log("Error fetching pipeline analytics", err);
    throw err;
  }
};

export const fetchLeadConversionAnalytics = async (filterPreset = 'this_month') => {
  try {
    const response = await axios.get(`/lead/leads/conversion-analytics/`, {
      params: { filter_preset: filterPreset }
    });
    return response.data;
  } catch (err) {
    console.log("Error fetching lead conversion analytics", err);
    throw err;
  }
};

export const fetchExpenseAnalytics = async (filterPreset = 'this_month') => {
  try {
    const response = await axios.get(`/accounting/expense/expense-analytics/`, {
      params: { filter_preset: filterPreset }
    });
    return response.data;
  } catch (err) {
    console.log("Error fetching expense analytics", err);
    throw err;
  }
};

export const fetchRecentDeals = async (pageSize = 5) => {
  try {
    const response = await axios.get(`/deal/deals/`, {
      params: { page_size: pageSize, ordering: '-created_at' }
    });
    return response.data?.results || response.data || [];
  } catch (err) {
    console.log("Error fetching recent deals", err);
    throw err;
  }
};

export const fetchRecentLeads = async (pageSize = 5) => {
  try {
    const response = await axios.get(`/lead/leads/`, {
      params: { page_size: pageSize, ordering: '-created_at' }
    });
    return response.data?.results || response.data || [];
  } catch (err) {
    console.log("Error fetching recent leads", err);
    throw err;
  }
};

export const fetchRecentInvoices = async (pageSize = 5) => {
  try {
    const response = await axios.get(`/invoices/invoices/`, {
      params: { perpage: pageSize, ordering: '-created_at' }
    });
    return response.data?.results || response.data || [];
  } catch (err) {
    console.log("Error fetching recent invoices", err);
    throw err;
  }
};

// Templates

////////////////////////// TEMPLATE - Actions //////////////////////////

export const loadTemplate = async (templateId) => {
  try {
    const response = await axios.get("/template/" + templateId + "/");
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Template fetched successfully!", "success");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be fetched!");
  }
};

export const templateToPDF = async (templateId) => {
  try {
    const response = await axios.post(
      "/template/" + templateId + "/print_pdf/",
      {},
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Template fetched successfully!", "success");
      fileDownload(response.data, "template.pdf");
      // return response.data;
    }
    console.log("FILE DOWNLOAD RESPONSE:", response);
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be downloaded!");
  }
};

export const templateToPDFPreview = async (templateId) => {
  try {
    const response = await axios.post(
      "/template/" + templateId + "/print_pdf/",
      {},
      {
        responseType: "blob",
      }
    );
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Template fetched successfully!", "success");
      // fileDownload(response.data, "template.html");
      return response.data;
    }
    console.log("FILE DOWNLOAD RESPONSE:", response);
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be downloaded!");
  }
};

export const loadTemplates = async (page, searchValue) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/template/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    url += `&rand=${new Date().getTime()}`;
    const response = await axios.get(url);
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Templates fetched successfully!", "success");
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "There was a problem loading Templates!");
  }
};

export const loadTemplatesWithType = async (type) => {
  try {
    let url = `/template/?name__startswith=${type}`;
    url += `&rand=${new Date().getTime()}`;
    const response = await axios.get(url);
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Templates fetched successfully!", "success");
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "There was a problem loading Templates!");
  }
};

export const createTemplate = async (data) => {
  try {
    const response = await axios.post(`/template/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 201) {
      notify("success", "Your Template has been saved!");
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be saved!");
  }
};

export const updateTemplate = async (templateId, data) => {
  try {
    const response = await axios.put(`/template/${templateId}/`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 200) {
      notify("success", "Updated the template");
      return response;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template could not be updated!");
  }
};

export const deleteTemplate = async (id) => {
  try {
    const response = await axios.delete(`/template/${id}/`);
    console.log("Response", response);
    notify("success", "Template deleted successfully");
    return "deleted";
  } catch (err) {
    console.log("Error", err);
    notify("error", "Template deleted Error");
  }
};

export const loadTemplateTypes = async () => {
  try {
    const response = await axios.get(`/template/template_types/`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response", response);
    if (response.status === 200) {
      // notify("Templates fetched successfully!", "success");
      return response.data;
    }
  } catch (err) {
    console.log("Error", err);
    notify("error", "There was a problem loading Template Types!");
  }
};

// ================== Password Verification ====================
export const verifyPassword = async (password) => {
  try {
    const response = await axios.post('/user/verify-password/', { password });
    return response.data;
  } catch (err) {
    return err.response?.data || { message: 'Verification failed' };
  }
};

// Sends an emailed verification code to the logged-in user (2FA users only)
export const requestVerificationOTP = async () => {
  try {
    const response = await axios.post('/user/request-verification-otp/');
    return response.data;
  } catch (err) {
    return err.response?.data || { message: 'Failed to send verification code' };
  }
};

export const verifyOTPCode = async (otp_code) => {
  try {
    const response = await axios.post('/user/verify-password/', { otp_code });
    return response.data;
  } catch (err) {
    return err.response?.data || { message: 'Verification failed' };
  }
};

// ================== Roles API ====================
export const loadRoles = async () => {
  try {
    const response = await axios.get('/user/role/');
    return response.data;
  } catch (err) {
    console.log("Error loading roles:", err);
    return [];
  }
};

export const loadPermissions = async () => {
  try {
    const response = await axios.get('/organization/app-permission/');
    return response.data;
  } catch (err) {
    console.log("Error loading permissions:", err);
    return [];
  }
};

// ================== Organization Settings API ====================
export const loadOrganizationSettings = async (organizationId) => {
  try {
    const response = await axios.get(`/organization/organization-settings/?organization=${organizationId}`);
    return response.data;
  } catch (err) {
    console.log("Error loading organization settings:", err);
    return null;
  }
};

export const getOrganizationSetting = async (id) => {
  try {
    const response = await axios.get(`/organization/organization-settings/${id}/`);
    return response.data;
  } catch (err) {
    console.log("Error fetching organization setting:", err);
    return null;
  }
};

export const createOrganizationSetting = async (data) => {
  try {
    const response = await axios.post('/organization/organization-settings/', data);
    if (response.status === 201) {
      notify("success", "Organization settings created successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error creating organization settings:", err);
    notify("error", "Failed to create organization settings");
    return null;
  }
};

export const updateOrganizationSetting = async (id, data) => {
  try {
    const response = await axios.put(`/organization/organization-settings/${id}/`, data);
    if (response.status === 200) {
      notify("success", "Organization settings updated successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error updating organization settings:", err);
    notify("error", "Failed to update organization settings");
    return null;
  }
};

export const applyDefaultEmployeeRole = async (settingId) => {
  try {
    const response = await axios.post(`/organization/organization-settings/${settingId}/apply_default_employee_role/`);
    if (response.status === 200) {
      notify("success", response.data.message || "Default role applied to all employees!");
      return response.data;
    }
  } catch (err) {
    console.log("Error applying default employee role:", err);
    notify("error", err.response?.data?.error || "Failed to apply default role");
    return null;
  }
};

// ================== Policy API ====================
export const loadPolicies = async () => {
  try {
    const response = await axios.get('/masters/policies/');
    return response.data;
  } catch (err) {
    console.log("Error loading policies:", err);
    return null;
  }
};

export const loadPolicyByType = async (type) => {
  try {
    const response = await axios.get(`/masters/policies/by-type/${type}/`);
    return response.data;
  } catch (err) {
    console.log("Error loading policy by type:", err);
    return null;
  }
};

export const createPolicy = async (data) => {
  try {
    const response = await axios.post('/masters/policies/', data);
    if (response.status === 201) {
      notify("success", "Policy created successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error creating policy:", err);
    notify("error", "Failed to create policy");
    return null;
  }
};

export const updatePolicy = async (id, data) => {
  try {
    const response = await axios.put(`/masters/policies/${id}/`, data);
    if (response.status === 200) {
      notify("success", "Policy updated successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error updating policy:", err);
    notify("error", "Failed to update policy");
    return null;
  }
};

////////////////////////// DEALS - Actions //////////////////////////

export const loadDeals = async (page, searchValue, filterStage, filterOwner, pageSize) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!pageSize) {
      pageSize = 100;
    }
    let url = `/deal/deals/?page=${page}&page_size=${pageSize}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (filterStage) {
      url += `&stage=${filterStage}`;
    }
    if (filterOwner) {
      url += `&owner=${filterOwner}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to load deals");
    return err;
  }
};

export const retrieveDeal = async (id) => {
  try {
    const response = await axios.get(`/deal/deals/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to retrieve deal");
    return err;
  }
};

export const addDeal = async (data) => {
  try {
    const response = await axios.post(`/deal/deals/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to create deal");
    return err;
  }
};

export const updateDeal = async (current, id) => {
  try {
    const response = await axios.put(`/deal/deals/${id}/`, current);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update deal");
    return err;
  }
};

export const deleteDeal = async (id) => {
  try {
    const response = await axios.delete(`/deal/deals/${id}/`);
    console.log("Response", response);
    notify("success", "Deal deleted successfully");
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete deal");
    return err;
  }
};

// Deal Contact Role Actions
export const addDealContactRole = async (data) => {
  try {
    const response = await axios.post(`/deal/contact-roles/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add contact role");
    return err;
  }
};

export const updateDealContactRole = async (data, id) => {
  try {
    const response = await axios.put(`/deal/contact-roles/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update contact role");
    return err;
  }
};

export const deleteDealContactRole = async (id) => {
  try {
    const response = await axios.delete(`/deal/contact-roles/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete contact role");
    return err;
  }
};

// Deal Competitor Actions
export const addDealCompetitor = async (data) => {
  try {
    const response = await axios.post(`/deal/competitors/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add competitor");
    return err;
  }
};

export const updateDealCompetitor = async (data, id) => {
  try {
    const response = await axios.put(`/deal/competitors/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update competitor");
    return err;
  }
};

export const deleteDealCompetitor = async (id) => {
  try {
    const response = await axios.delete(`/deal/competitors/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete competitor");
    return err;
  }
};

// Deal Activity Actions
export const addDealActivity = async (data) => {
  try {
    const response = await axios.post(`/deal/activities/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add activity");
    return err;
  }
};

export const updateDealActivity = async (data, id) => {
  try {
    const response = await axios.put(`/deal/activities/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update activity");
    return err;
  }
};

export const deleteDealActivity = async (id) => {
  try {
    const response = await axios.delete(`/deal/activities/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete activity");
    return err;
  }
};

// Deal Attachment Actions
export const addDealAttachment = async (formData) => {
  try {
    const response = await axios.post(`/deal/attachments/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add attachment");
    return err;
  }
};

export const updateDealAttachment = async (formData, id) => {
  try {
    const response = await axios.put(`/deal/attachments/${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update attachment");
    return err;
  }
};

export const deleteDealAttachment = async (id) => {
  try {
    const response = await axios.delete(`/deal/attachments/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete attachment");
    return err;
  }
};

export const removeDocumentFromDeals = async (id, doc_id) => {
  try {
    const response = await axios.post(`/deal/deals/${id}/removeAttachment/`, {
      documents: [doc_id],
    });
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

export const loadDealStageHistory = async (dealId) => {
  try {
    const response = await axios.get(`/deal/deals/${dealId}/stage_history/`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to load stage history");
    return err;
  }
};

////////////////////////// CAMPAIGNS - Actions //////////////////////////

export const loadCampaigns = async (page, searchValue, filterType, filterStatus) => {
  try {
    if (!page) {
      page = 1;
    }
    let url = `/campaign/campaigns/?page=${page}&page_size=100`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    if (filterType) {
      url += `&type=${filterType}`;
    }
    if (filterStatus) {
      url += `&status=${filterStatus}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to load campaigns");
    return err;
  }
};

export const retrieveCampaign = async (id) => {
  try {
    const response = await axios.get(`/campaign/campaigns/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to retrieve campaign");
    return err;
  }
};

export const addCampaign = async (data) => {
  try {
    const response = await axios.post(`/campaign/campaigns/`, data);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to create campaign");
    return err;
  }
};

export const updateCampaign = async (current, id) => {
  try {
    const response = await axios.put(`/campaign/campaigns/${id}/`, current);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update campaign");
    return err;
  }
};

export const deleteCampaign = async (id) => {
  try {
    const response = await axios.delete(`/campaign/campaigns/${id}/`);
    console.log("Response", response);
    notify("success", "Campaign deleted successfully");
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete campaign");
    return err;
  }
};

// Campaign Lead relationships
export const addCampaignLead = async (data) => {
  try {
    const response = await axios.post(`/campaign/leads/`, data);
    console.log("Response", response);
    notify("success", "Lead added to campaign successfully");
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add lead to campaign");
    return err;
  }
};

export const removeCampaignLead = async (id) => {
  try {
    const response = await axios.delete(`/campaign/leads/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to remove lead from campaign");
    return err;
  }
};

// Campaign Contact relationships
export const addCampaignContact = async (data) => {
  try {
    const response = await axios.post(`/campaign/contacts/`, data);
    console.log("Response", response);
    notify("success", "Contact added to campaign successfully");
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add contact to campaign");
    return err;
  }
};

export const removeCampaignContact = async (id) => {
  try {
    const response = await axios.delete(`/campaign/contacts/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to remove contact from campaign");
    return err;
  }
};

// Campaign Deal relationships
export const addCampaignDeal = async (data) => {
  try {
    const response = await axios.post(`/campaign/deals/`, data);
    console.log("Response", response);
    notify("success", "Deal added to campaign successfully");
    return response.data;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to add deal to campaign");
    return err;
  }
};

export const removeCampaignDeal = async (id) => {
  try {
    const response = await axios.delete(`/campaign/deals/${id}/`);
    console.log("Response", response);
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to remove deal from campaign");
    return err;
  }
};

// Lead Import for Campaigns
export const downloadLeadImportTemplate = async (format = 'xlsx') => {
  try {
    const response = await axios.get(`/campaign/campaigns/download_lead_import_template/`, {
      params: { file_format: format },
      responseType: 'blob'
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to download template");
    throw err;
  }
};

export const parseLeadImportFile = async (campaignId, formData) => {
  try {
    const response = await axios.post(
      `/campaign/campaigns/${campaignId}/parse_import_file/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const importCampaignLeads = async (campaignId, data) => {
  try {
    const response = await axios.post(
      `/campaign/campaigns/${campaignId}/import_leads/`,
      data
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// Lead Import from the Leads page (no campaign association): sample -> preview -> confirm
export const downloadLeadsImportSample = async () => {
  try {
    const response = await axios.get(`/lead/leads/import_sample/`, { responseType: 'blob' });
    fileDownload(response.data, 'lead_import_sample.xlsx');
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const previewLeadsImport = async (formData) => {
  try {
    // Only uploads the file; the rows are checked by a background job.
    const response = await axios.post(`/lead/leads/import_preview/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const getLeadsImportStatus = async (jobId) => {
  try {
    const response = await axios.get(`/lead/leads/import_status/`, { params: { job_id: jobId } });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const confirmLeadsImport = async (data) => {
  try {
    const response = await axios.post(`/lead/leads/import_confirm/`, data);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// Contact Import for Campaigns
export const downloadContactImportTemplate = async (format = 'xlsx') => {
  try {
    const response = await axios.get(`/campaign/campaigns/download_contact_import_template/`, {
      params: { file_format: format },
      responseType: 'blob'
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to download template");
    throw err;
  }
};

export const parseContactImportFile = async (campaignId, formData) => {
  try {
    const response = await axios.post(
      `/campaign/campaigns/${campaignId}/parse_contact_import_file/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const importCampaignContacts = async (campaignId, data) => {
  try {
    const response = await axios.post(
      `/campaign/campaigns/${campaignId}/import_contacts/`,
      data
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// Campaign UTM Links
export const getCampaignUTMLinks = async (campaignId) => {
  try {
    const response = await axios.get(`/campaign/campaigns/${campaignId}/utm_links/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading UTM links:", err);
    return null;
  }
};

export const generateCampaignUTMLinks = async (campaignId, data) => {
  try {
    const response = await axios.post(
      `/campaign/campaigns/${campaignId}/generate_utm_links/`,
      data
    );
    if (response.status === 200 || response.status === 201) {
      return response.data;
    }
  } catch (err) {
    console.log("Error generating UTM links:", err);
    notify("error", "Failed to generate UTM links", err.response?.data?.error);
    throw err;
  }
};

export const deleteCampaignUTMLink = async (campaignId, linkId) => {
  try {
    const response = await axios.delete(
      `/campaign/campaigns/${campaignId}/utm_links/${linkId}/`
    );
    if (response.status === 200 || response.status === 204) {
      return { success: true };
    }
  } catch (err) {
    console.log("Error deleting UTM link:", err);
    notify("error", "Failed to delete UTM link", null);
    throw err;
  }
};

export const getCampaignUTMAnalytics = async (campaignId) => {
  try {
    const response = await axios.get(`/campaign/campaigns/${campaignId}/utm_analytics/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading UTM analytics:", err);
    return null;
  }
};

// ============================================
// TIMESHEET & PAYROLL API FUNCTIONS
// ============================================

// Departments
export const loadDepartments = async () => {
  try {
    const response = await axios.get('/employee/employees/departments/');
    if (response.status === 200) {
      return response.data.results || response.data;
    }
  } catch (err) {
    console.log("Error loading departments:", err);
    return [];
  }
};

export const loadDepartmentsByOrganization = async (organizationId) => {
  try {
    const response = await axios.get(`/employee/employees/departments/?organization=${organizationId}`);
    if (response.status === 200) {
      return response.data.results || response.data;
    }
  } catch (err) {
    console.log("Error loading departments:", err);
    return [];
  }
};

// Import Attendance
export const importAttendanceExcel = async (file, organizationId) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('organization', organizationId);

    const response = await axios.post(
      `/attendance/attendance/import_excel/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    if (response.status === 200 || response.status === 201) {
      notify("success", "Attendance imported successfully!", null);
      return response.data;
    }
  } catch (err) {
    console.log("Error importing attendance:", err);
    notify("error", "Failed to import attendance", err.response?.data?.error || JSON.stringify(err.response?.data));
    throw err;
  }
};

export const loadImportHistory = async (page = 1, pageSize = 10, organizationId) => {
  try {
    let url = `/attendance/import-history/?page=${page}&page_size=${pageSize}`;
    if (organizationId) {
      url += `&organization=${organizationId}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading import history:", err);
    notify("error", "Failed to load import history", null);
    return null;
  }
};

export const downloadAttendanceSample = async () => {
  try {
    const response = await axios.get('/attendance/attendance/download_sample/', {
      responseType: 'blob'
    });
    return response.data;
  } catch (err) {
    console.log("Error downloading sample:", err);
    notify("error", "Failed to download sample file", null);
    return null;
  }
};

// Machine Logs
export const loadMachineLogs = async (filters = {}, page = 1, pageSize = 10) => {
  try {
    let url = `/iclock/attendance-logs/?page=${page}&page_size=${pageSize}`;

    if (filters.dateFrom) {
      url += `&date_from=${filters.dateFrom}`;
    }
    if (filters.dateTo) {
      url += `&date_to=${filters.dateTo}`;
    }
    if (filters.machineSerial) {
      const serials = Array.isArray(filters.machineSerial)
        ? filters.machineSerial.join(',')
        : filters.machineSerial;
      url += `&machine_sn=${serials}`;
    }
    if (filters.employees && filters.employees.length > 0) {
      url += `&employees=${filters.employees.join(',')}`;
    }

    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading machine logs:", err);
    notify("error", "Failed to load machine logs", null);
    return null;
  }
};

// Biometric Devices
export const loadDevices = async (pageSize = 1000) => {
  try {
    const response = await axios.get(`/iclock/devices/?page_size=${pageSize}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading devices:", err);
    return null;
  }
};

export const processMachineLogs = async (logIds) => {
  try {
    const response = await axios.post(`/iclock/attendance-logs/process/`, {
      log_ids: logIds
    });
    if (response.status === 200) {
      notify("success", "Machine logs processed successfully!", null);
      return response.data;
    }
  } catch (err) {
    console.log("Error processing logs:", err);
    notify("error", "Failed to process logs", err.response?.data?.error);
    return null;
  }
};

export const deleteMachineLogs = async (logIds) => {
  try {
    const response = await axios.post(`/iclock/attendance-logs/bulk_delete/`, {
      log_ids: logIds
    });
    if (response.status === 200 || response.status === 204) {
      notify("success", "Machine logs deleted successfully!", null);
      return true;
    }
  } catch (err) {
    console.log("Error deleting logs:", err);
    notify("error", "Failed to delete logs", err.response?.data?.error);
    return false;
  }
};

// Run Payroll
export const runPayroll = async (data) => {
  try {
    const response = await axios.post(`/payroll/run-payroll-2/run_payroll/`, data);
    if (response.status === 200 || response.status === 201) {
      return response.data;
    }
  } catch (err) {
    console.log("Error running payroll:", err);
    notify("error", "Failed to run payroll", err.response?.data?.error || JSON.stringify(err.response?.data));
    throw err;
  }
};

export const checkPayrollProgress = async (taskId) => {
  try {
    const response = await axios.get(`/payroll/run-payroll-2/check_progress/?task_id=${taskId}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error checking payroll progress:", err);
    return null;
  }
};

export const cancelPayrollTask = async (taskId) => {
  try {
    const response = await axios.post(`/payroll/run-payroll-2/cancel_task/`, { task_id: taskId });
    if (response.status === 200) {
      notify("success", "Payroll task cancelled", null);
      return response.data;
    }
  } catch (err) {
    console.log("Error cancelling payroll:", err);
    notify("error", "Failed to cancel payroll task", null);
    return null;
  }
};

export const loadPayrollResults = async (runId, page = 1, pageSize = 10) => {
  try {
    const response = await axios.get(`/payroll/run-payroll-results/?run_id=${runId}&page=${page}&page_size=${pageSize}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading payroll results:", err);
    return null;
  }
};

// Payroll History
export const loadPayrollHistory = async (page = 1, pageSize = 10, organizationId) => {
  try {
    let url = `/payroll/payroll-histories/?page=${page}&page_size=${pageSize}`;
    if (organizationId) {
      url += `&organization=${organizationId}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading payroll history:", err);
    notify("error", "Failed to load payroll history", null);
    return null;
  }
};

export const loadPayrollHistoryDetail = async (id) => {
  try {
    const response = await axios.get(`/payroll/payroll-histories/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading payroll history detail:", err);
    return null;
  }
};

export const deletePayrollHistory = async (id) => {
  try {
    const response = await axios.delete(`/payroll/payroll-histories/${id}/`);
    if (response.status === 200 || response.status === 204) {
      notify("success", "Payroll history deleted successfully!", null);
      return true;
    }
  } catch (err) {
    console.log("Error deleting payroll history:", err);
    notify("error", "Failed to delete payroll history", null);
    return false;
  }
};

// Update Payroll History Status
export const updatePayrollHistoryStatus = async (id, status) => {
  try {
    const response = await axios.patch(`/payroll/payroll-histories/${id}/update_status/`, { status });
    if (response.status === 200) {
      notify("success", "Payroll status updated successfully!", null);
      return response.data;
    }
  } catch (err) {
    console.log("Error updating payroll status:", err);
    notify("error", "Failed to update payroll status", err.response?.data?.error || null);
    return null;
  }
};

// Confirm Payroll (after dry run)
export const confirmPayroll = async (data) => {
  try {
    const response = await axios.post(`/payroll/run-payroll-2/confirm_payroll/`, data);
    return response.data;
  } catch (err) {
    console.log("Error confirming payroll:", err);
    notify("error", "Failed to confirm payroll", err.response?.data?.error || JSON.stringify(err.response?.data));
    return null;
  }
};

// Get current user's payslips (no employee ID required - secure endpoint)
export const getMyPayslips = async (year = null) => {
  try {
    let url = `/payroll/payroll-histories/my_payslips/`;
    if (year) {
      url += `?year=${year}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading my payslips:", err);
    return [];
  }
};

// Download payslip PDF
export const downloadPayslip = async (payslipId) => {
  try {
    const response = await axios.get(`/payroll/payroll-histories/${payslipId}/download_payslip/`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (err) {
    console.log("Error downloading payslip:", err);
    notify("error", "Failed to download payslip", null);
    return null;
  }
};

////////////////////////// ATTENDANCE - Actions //////////////////////////

// Load attendance records with filters
export const loadAttendanceRecords = async (page = 1, pageSize = 10, organizationId, filters = {}) => {
  try {
    let url = `/attendance/attendance/?page=${page}&page_size=${pageSize}`;

    if (organizationId) {
      url += `&organization=${organizationId}`;
    }
    if (filters.employee) {
      url += `&employee=${filters.employee}`;
    }
    if (filters.date_from) {
      url += `&date_from=${filters.date_from}`;
    }
    if (filters.date_to) {
      url += `&date_to=${filters.date_to}`;
    }
    if (filters.status) {
      url += `&status=${filters.status}`;
    }

    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading attendance records:", err);
    notify("error", "Failed to load attendance records", null);
    return null;
  }
};

// Load single attendance record
export const loadAttendance = async (id) => {
  try {
    const response = await axios.get(`/attendance/attendance/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading attendance:", err);
    notify("error", "Failed to load attendance record", null);
    return null;
  }
};

// Create attendance record
export const createAttendance = async (data) => {
  try {
    const response = await axios.post(`/attendance/attendance/`, data);
    if (response.status === 201) {
      notify("success", "Attendance record created successfully!", null);
      return response.data;
    }
  } catch (err) {
    console.log("Error creating attendance:", err);
    notify("error", "Failed to create attendance record", null);
    throw err;
  }
};

// Update attendance record
export const updateAttendance = async (id, data) => {
  try {
    const response = await axios.put(`/attendance/attendance/${id}/`, data);
    if (response.status === 200) {
      notify("success", "Attendance record updated successfully!", null);
      return response.data;
    }
  } catch (err) {
    console.log("Error updating attendance:", err);
    notify("error", "Failed to update attendance record", null);
    throw err;
  }
};

// Delete attendance record
export const deleteAttendance = async (id) => {
  try {
    const response = await axios.delete(`/attendance/attendance/${id}/`);
    if (response.status === 200 || response.status === 204) {
      notify("success", "Attendance record deleted successfully!", null);
      return true;
    }
  } catch (err) {
    console.log("Error deleting attendance:", err);
    notify("error", "Failed to delete attendance record", null);
    return false;
  }
};

// Calculate attendance from iclock device logs
export const calculateAttendanceFromLogs = async (organizationId, filters = {}) => {
  try {
    const data = { organization: organizationId };
    if (filters.employee) {
      data.employee_id = filters.employee;
    }
    if (filters.date_from) {
      data.date_from = filters.date_from;
    }
    if (filters.date_to) {
      data.date_to = filters.date_to;
    }

    const response = await axios.post(`/attendance/attendance/calculate_from_logs/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error calculating attendance:", err);
    const errorMsg = err.response?.data?.error || "Failed to calculate attendance";
    notify("error", errorMsg, null);
    throw err;
  }
};

// Load work shifts
export const loadWorkShifts = async (page = 1, pageSize = 1000, organizationId) => {
  try {
    let url = `/attendance/shifts/?page=${page}&page_size=${pageSize}`;
    if (organizationId) {
      url += `&organization=${organizationId}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading work shifts:", err);
    return { results: [] };
  }
};

////////////////////////// ASSETS //////////////////////////

// Load assets
export const loadAssets = async (page = 1, search = '', pageSize = 10, status = null) => {
  try {
    let url = `/assets/assets/?page=${page}&page_size=${pageSize}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading assets:", err);
    return null;
  }
};

// Retrieve single asset
export const retrieveAsset = async (id) => {
  try {
    const response = await axios.get(`/assets/assets/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error retrieving asset:", err);
    return null;
  }
};

// Add asset
export const addAsset = async (data) => {
  try {
    const response = await axios.post(`/assets/assets/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    return response;
  } catch (err) {
    console.log("Error adding asset:", err);
    notify("error", "Failed to create asset", null);
    return null;
  }
};

// Update asset
export const updateAsset = async (data, id) => {
  try {
    const response = await axios.patch(`/assets/assets/${id}/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error updating asset:", err);
    notify("error", "Failed to update asset", null);
    return null;
  }
};

// Delete asset
export const deleteAsset = async (id) => {
  try {
    const response = await axios.delete(`/assets/assets/${id}/`);
    if (response.status === 200 || response.status === 204) {
      return true;
    }
  } catch (err) {
    console.log("Error deleting asset:", err);
    notify("error", "Failed to delete asset", null);
    return false;
  }
};

// Generate barcode for asset
export const generateAssetBarcode = async (id) => {
  try {
    const response = await axios.post(`/assets/assets/${id}/generate_barcode/`);
    return response;
  } catch (err) {
    console.log("Error generating barcode:", err);
    return null;
  }
};

// Generate barcode sheet URL
// Format: TESONLLP-AST<YYYY><MM><NNNN>
export const getBarcodeSheetUrl = (params) => {
  const { year, month, startNumber, endNumber, repeatCount, includeBarcode, includeQrcode } = params;

  // Get base URL and remove trailing slash if present
  let baseUrl = axios.defaults.baseURL || '';
  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }
  // Replace 0.0.0.0 with localhost for browser compatibility
  baseUrl = baseUrl.replace('0.0.0.0', 'localhost');

  // Default to current year/month if not provided
  const currentDate = new Date();
  const useYear = year || currentDate.getFullYear();
  const useMonth = month || String(currentDate.getMonth() + 1).padStart(2, '0');

  let url = `${baseUrl}/assets/generate-barcode-sheet/?year=${useYear}&month=${useMonth}`;
  url += `&start_number=${startNumber}`;

  if (endNumber) {
    url += `&end_number=${endNumber}`;
  }
  if (repeatCount && repeatCount > 1) {
    url += `&repeat_count=${repeatCount}`;
  }
  url += `&include_barcode=${includeBarcode ? 'true' : 'false'}`;
  url += `&include_qrcode=${includeQrcode ? 'true' : 'false'}`;

  return url;
};

// Load asset history
export const loadAssetHistory = async (id) => {
  try {
    const response = await axios.get(`/assets/assets/${id}/history/`);
    return response;
  } catch (err) {
    console.log("Error loading asset history:", err);
    return null;
  }
};

// Load asset categories
export const loadAssetCategories = async () => {
  try {
    const response = await axios.get(`/assets/categories/`);
    return response;
  } catch (err) {
    console.log("Error loading categories:", err);
    return null;
  }
};

// Load asset locations
export const loadAssetLocations = async () => {
  try {
    const response = await axios.get(`/assets/locations/`);
    return response;
  } catch (err) {
    console.log("Error loading locations:", err);
    return null;
  }
};

// Asset Assignments
export const loadAssetAssignments = async (assetId = null, page = 1, pageSize = 10) => {
  try {
    let url = `/assets/assignments/?page=${page}&page_size=${pageSize}`;
    if (assetId) {
      url += `&asset=${assetId}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading assignments:", err);
    return null;
  }
};

export const addAssetAssignment = async (data) => {
  try {
    const response = await axios.post(`/assets/assignments/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    return response;
  } catch (err) {
    console.log("Error adding assignment:", err);
    notify("error", "Failed to create assignment", null);
    return null;
  }
};

export const updateAssetAssignment = async (data, id) => {
  try {
    const response = await axios.patch(`/assets/assignments/${id}/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error updating assignment:", err);
    notify("error", "Failed to update assignment", null);
    return null;
  }
};

export const deleteAssetAssignment = async (id) => {
  try {
    const response = await axios.delete(`/assets/assignments/${id}/`);
    if (response.status === 200 || response.status === 204) {
      return true;
    }
  } catch (err) {
    console.log("Error deleting assignment:", err);
    notify("error", "Failed to delete assignment", null);
    return false;
  }
};

// Asset Maintenance
export const loadAssetMaintenance = async (assetId = null, page = 1, pageSize = 10) => {
  try {
    let url = `/assets/maintenance/?page=${page}&page_size=${pageSize}`;
    if (assetId) {
      url += `&asset=${assetId}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading maintenance:", err);
    return null;
  }
};

export const addAssetMaintenance = async (data) => {
  try {
    const response = await axios.post(`/assets/maintenance/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    return response;
  } catch (err) {
    console.log("Error adding maintenance:", err);
    notify("error", "Failed to create maintenance record", null);
    return null;
  }
};

export const updateAssetMaintenance = async (data, id) => {
  try {
    const response = await axios.patch(`/assets/maintenance/${id}/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error updating maintenance:", err);
    notify("error", "Failed to update maintenance record", null);
    return null;
  }
};

export const deleteAssetMaintenance = async (id) => {
  try {
    const response = await axios.delete(`/assets/maintenance/${id}/`);
    if (response.status === 200 || response.status === 204) {
      return true;
    }
  } catch (err) {
    console.log("Error deleting maintenance:", err);
    notify("error", "Failed to delete maintenance record", null);
    return false;
  }
};

// Asset Images
export const loadAssetImages = async (assetId = null, page = 1, pageSize = 100) => {
  try {
    let url = `/assets/images/?page=${page}&page_size=${pageSize}`;
    if (assetId) {
      url += `&asset=${assetId}`;
    }
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading images:", err);
    return null;
  }
};

export const uploadAssetImage = async (assetId, file, caption = '', isPrimary = false, order = 0, categoryId = null) => {
  try {
    const formData = new FormData();
    formData.append('asset', assetId);
    formData.append('image', file);
    if (caption) formData.append('caption', caption);
    formData.append('is_primary', isPrimary);
    formData.append('order', order);
    if (categoryId) {
      formData.append('category_id', categoryId);
    }

    const response = await axios.post(`/assets/images/`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
    return response;
  } catch (err) {
    console.log("Error uploading image:", err);
    notify("error", "Failed to upload image", null);
    return null;
  }
};

export const updateAssetImage = async (data, id) => {
  try {
    const response = await axios.patch(`/assets/images/${id}/`, data, {
      headers: { "Content-Type": "application/json" }
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error updating image:", err);
    notify("error", "Failed to update image", null);
    return null;
  }
};

export const deleteAssetImage = async (id) => {
  try {
    const response = await axios.delete(`/assets/images/${id}/`);
    if (response.status === 200 || response.status === 204) {
      return true;
    }
  } catch (err) {
    console.log("Error deleting image:", err);
    notify("error", "Failed to delete image", null);
    return false;
  }
};

export const setAssetImagePrimary = async (id) => {
  try {
    const response = await axios.post(`/assets/images/${id}/set_primary/`);
    return response;
  } catch (err) {
    console.log("Error setting primary image:", err);
    notify("error", "Failed to set primary image", null);
    return null;
  }
};

//////////////Contract Types/////////////

export const loadContractTypes = async (page, searchValue, page_size) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!page_size) {
      page_size = 100;
    }
    let url = `contract/types/?page=${page}&page_size=${page_size}&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteContractType = async (id) => {
  try {
    const response = await axios.delete(`/contract/types/${id}/`);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const fetchContractType = async (id) => {
  try {
    const response = await axios.get(`/contract/types/${id}/?rand=${new Date().getTime()}`);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const addContractType = async (data) => {
  try {
    const response = await axios.post(`/contract/types/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const updateContractType = async (data, id) => {
  try {
    const response = await axios.put(`/contract/types/${id}/`, data);
    console.log("Response", response);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

//////////////Contracts/////////////

export const loadContracts = async (page, searchValue, page_size) => {
  try {
    if (!page) {
      page = 1;
    }
    if (!page_size) {
      page_size = 100;
    }
    let url = `contract/?page=${page}&page_size=${page_size}&rand=${new Date().getTime()}`;
    if (searchValue) {
      url += `&search=${encodeURIComponent(searchValue)}`;
    }
    const response = await axios.get(url);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const deleteContract = async (id) => {
  try {
    const response = await axios.delete(`/contract/${id}/`);
    console.log("Response", response);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const addContract = async (data) => {
  try {
    const response = await axios.post(`/contract/`, data);
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateContract = async (data, id) => {
  try {
    const response = await axios.put(`/contract/${id}/`, data);
    return response;
  } catch (err) {
    throw err;
  }
};

export const fetchContract = async (id) => {
  try {
    const response = await axios.get(`/contract/${id}/?rand=${new Date().getTime()}`);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return null;
  }
};

// The contract's exported PDF, as a blob to save.
export const downloadContractPdf = async (id) => {
  return axios.get(`/contract/${id}/pdf/`, { responseType: "blob" });
};

// Placeholders a contract type's template can use.
export const loadContractPlaceholders = async () => {
  return axios.get(`/contract/types/placeholders/`);
};

export const exportContractToPdf = async (id) => {
  try {
    const response = await axios.post(`/contract/${id}/export_pdf/`);
    return response;
  } catch (err) {
    console.log("Error exporting contract to PDF:", err);
    notify("error", "Failed to export contract to PDF");
    throw err;
  }
};

// ============== Document Workflow APIs ==============

export const updateDocumentWorkflow = async (id, data) => {
  try {
    const response = await axios.patch(`/document/document/${id}/edit/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    notify("error", "Failed to save document workflow");
    throw err;
  }
};

export const addDocumentRecipient = async (documentId, recipientData) => {
  try {
    const response = await axios.post(`/document/document/${documentId}/recipients/`, recipientData);
    if (response.status === 201 || response.status === 200) {
      return response.data;
    }
  } catch (err) {
    notify("error", "Failed to add recipient");
    throw err;
  }
};

export const removeDocumentRecipient = async (documentId, recipientId) => {
  try {
    const response = await axios.delete(`/document/document/${documentId}/recipients/${recipientId}/`);
    if (response.status === 204) {
      return true;
    }
  } catch (err) {
    notify("error", "Failed to remove recipient");
    throw err;
  }
};

export const updateDocumentRecipient = async (documentId, recipientId, data) => {
  try {
    const response = await axios.put(`/document/document/${documentId}/recipients/${recipientId}/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    notify("error", "Failed to update recipient");
    throw err;
  }
};

export const addDocumentField = async (documentId, fieldData) => {
  try {
    const response = await axios.post(`/document/document/${documentId}/fields/`, fieldData);
    if (response.status === 201 || response.status === 200) {
      return response.data;
    }
  } catch (err) {
    throw err;
  }
};

export const updateDocumentField = async (documentId, fieldId, data) => {
  try {
    const response = await axios.put(`/document/document/${documentId}/fields/${fieldId}/`, data);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    throw err;
  }
};

export const deleteDocumentField = async (documentId, fieldId) => {
  try {
    const response = await axios.delete(`/document/document/${documentId}/fields/${fieldId}/`);
    if (response.status === 204) {
      return true;
    }
  } catch (err) {
    throw err;
  }
};

export const sendDocumentForSigning = async (documentId, distributionData) => {
  try {
    const response = await axios.post(`/document/document/${documentId}/send/`, distributionData);
    if (response.status === 200 || response.status === 201) {
      notify("success", "Document sent for signing!");
      return response.data;
    }
  } catch (err) {
    notify("error", "Failed to send document for signing");
    throw err;
  }
};

export const getDocumentWorkflowStatus = async (documentId) => {
  try {
    const response = await axios.get(`/document/document/${documentId}/workflow_status/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    throw err;
  }
};

// Send document workflow - triggers token generation and email notifications
export const sendDocumentWorkflow = async (documentId, distributionData) => {
  try {
    const response = await axios.post(`/document/document/${documentId}/send/`, distributionData);
    if (response.status === 200 || response.status === 201 || response.status === 207) {
      notify("success", "Document sent successfully!");
      return response.data;
    }
  } catch (err) {
    notify("error", "Failed to send document");
    throw err;
  }
};

// Get email logs for a document
export const getDocumentEmailLogs = async (documentId) => {
  try {
    const response = await axios.get(`/document/document/${documentId}/email_logs/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.error("Failed to load email logs:", err);
    throw err;
  }
};

// Resend email to a specific recipient
export const resendDocumentEmail = async (documentId, emailLogId) => {
  try {
    const response = await axios.post(`/document/document/${documentId}/resend_email/`, {
      email_log_id: emailLogId
    });
    if (response.status === 200) {
      notify("success", "Email resent successfully!");
      return response.data;
    }
  } catch (err) {
    notify("error", "Failed to resend email");
    throw err;
  }
};

// ============== Employee Daily Updates APIs ==============

// Load daily updates with filters
export const loadDailyUpdates = async (page = 1, pageSize = 10, filters = {}) => {
  try {
    let url = `/employee/daily-updates/?page=${page}&page_size=${pageSize}`;
    if (filters.employee) {
      url += `&employee=${filters.employee}`;
    }
    if (filters.update_date_from) {
      url += `&update_date_from=${filters.update_date_from}`;
    }
    if (filters.update_date_to) {
      url += `&update_date_to=${filters.update_date_to}`;
    }
    if (filters.department) {
      url += `&department=${filters.department}`;
    }
    if (filters.search) {
      url += `&search=${filters.search}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading daily updates:", err);
    return null;
  }
};

// Load current user's daily updates
export const loadMyDailyUpdates = async (page = 1, pageSize = 10) => {
  try {
    const response = await axios.get(`/employee/daily-updates/my_updates/?page=${page}&page_size=${pageSize}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading my daily updates:", err);
    return null;
  }
};

// Get today's update for current user
export const getTodayUpdate = async () => {
  try {
    const response = await axios.get(`/employee/daily-updates/today/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    if (err.response?.status === 404) {
      return null; // No update for today
    }
    console.log("Error getting today's update:", err);
    return null;
  }
};

// Get single daily update
export const fetchDailyUpdate = async (id) => {
  try {
    const response = await axios.get(`/employee/daily-updates/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error fetching daily update:", err);
    return null;
  }
};

// Create daily update
export const createDailyUpdate = async (data) => {
  try {
    const response = await axios.post(`/employee/daily-updates/`, data);
    if (response.status === 201) {
      const msg = data.status === 'SUBMITTED' ? "Daily update submitted successfully!" : "Daily update saved as draft.";
      notify("success", msg);
      return response.data;
    }
  } catch (err) {
    console.log("Error creating daily update:", err);
    const detail = err.response?.data?.tasks_completed?.[0] || err.response?.data?.detail;
    notify("error", "Failed to save daily update", detail);
    throw err;
  }
};

// Update daily update
export const updateDailyUpdate = async (id, data) => {
  try {
    const response = await axios.put(`/employee/daily-updates/${id}/`, data);
    if (response.status === 200) {
      const msg = data.status === 'SUBMITTED' ? "Daily update submitted successfully!" : "Daily update saved as draft.";
      notify("success", msg);
      return response.data;
    }
  } catch (err) {
    console.log("Error updating daily update:", err);
    const detail = err.response?.data?.tasks_completed?.[0] || err.response?.data?.detail;
    notify("error", "Failed to save daily update", detail);
    throw err;
  }
};

// Delete daily update
export const deleteDailyUpdate = async (id) => {
  try {
    const response = await axios.delete(`/employee/daily-updates/${id}/`);
    if (response.status === 200 || response.status === 204) {
      notify("success", "Daily update deleted successfully!");
      return true;
    }
  } catch (err) {
    console.log("Error deleting daily update:", err);
    notify("error", "Failed to delete daily update", null);
    return false;
  }
};

// Get daily updates analytics (for reports)
export const getDailyUpdatesAnalytics = async (filters = {}) => {
  try {
    let url = `/employee/daily-updates/analytics/?`;
    if (filters.date_from) {
      url += `date_from=${filters.date_from}&`;
    }
    if (filters.date_to) {
      url += `date_to=${filters.date_to}&`;
    }
    if (filters.organization) {
      url += `organization=${filters.organization}&`;
    }
    if (filters.employee) {
      url += `employee=${filters.employee}&`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading daily updates analytics:", err);
    return null;
  }
};

// ============== Employee Reviews APIs ==============

// Load employee reviews with filters
export const loadEmployeeReviews = async (page = 1, pageSize = 10, filters = {}) => {
  try {
    let url = `/employee/reviews/?page=${page}&page_size=${pageSize}`;
    if (filters.employee) {
      url += `&employee=${filters.employee}`;
    }
    if (filters.reviewer) {
      url += `&reviewer=${filters.reviewer}`;
    }
    if (filters.review_type) {
      url += `&review_type=${filters.review_type}`;
    }
    if (filters.status) {
      url += `&status=${filters.status}`;
    }
    if (filters.search) {
      url += `&search=${filters.search}`;
    }
    const response = await axios.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading employee reviews:", err);
    return null;
  }
};

// Load current user's reviews
export const loadMyReviews = async (page = 1, pageSize = 10) => {
  try {
    const response = await axios.get(`/employee/reviews/my_reviews/?page=${page}&page_size=${pageSize}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error loading my reviews:", err);
    return null;
  }
};

// Get single review
export const fetchEmployeeReview = async (id) => {
  try {
    const response = await axios.get(`/employee/reviews/${id}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    console.log("Error fetching employee review:", err);
    return null;
  }
};

// Create employee review
export const createEmployeeReview = async (data) => {
  try {
    const response = await axios.post(`/employee/reviews/`, data);
    if (response.status === 201) {
      notify("success", "Review created successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error creating employee review:", err);
    notify("error", "Failed to create review", null);
    throw err;
  }
};

// Update employee review
export const updateEmployeeReview = async (id, data) => {
  try {
    const response = await axios.put(`/employee/reviews/${id}/`, data);
    if (response.status === 200) {
      notify("success", "Review updated successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error updating employee review:", err);
    notify("error", "Failed to update review", null);
    throw err;
  }
};

// Delete employee review
export const deleteEmployeeReview = async (id) => {
  try {
    const response = await axios.delete(`/employee/reviews/${id}/`);
    if (response.status === 200 || response.status === 204) {
      notify("success", "Review deleted successfully!");
      return true;
    }
  } catch (err) {
    console.log("Error deleting employee review:", err);
    notify("error", "Failed to delete review", null);
    return false;
  }
};

// Submit review (change status from DRAFT to SUBMITTED)
export const submitReview = async (id) => {
  try {
    const response = await axios.post(`/employee/reviews/${id}/submit/`);
    if (response.status === 200) {
      notify("success", "Review submitted successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error submitting review:", err);
    notify("error", "Failed to submit review", err.response?.data?.error);
    throw err;
  }
};

// Acknowledge review (employee acknowledges a submitted review)
export const acknowledgeReview = async (id, employeeComments = null) => {
  try {
    const data = employeeComments ? { employee_comments: employeeComments } : {};
    const response = await axios.post(`/employee/reviews/${id}/acknowledge/`, data);
    if (response.status === 200) {
      notify("success", "Review acknowledged successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error acknowledging review:", err);
    notify("error", "Failed to acknowledge review", err.response?.data?.error);
    throw err;
  }
};

// Complete review (mark as completed after acknowledgment)
export const completeReview = async (id) => {
  try {
    const response = await axios.post(`/employee/reviews/${id}/complete/`);
    if (response.status === 200) {
      notify("success", "Review completed successfully!");
      return response.data;
    }
  } catch (err) {
    console.log("Error completing review:", err);
    notify("error", "Failed to complete review", err.response?.data?.error);
    throw err;
  }
};

// ======================== BANK STATEMENTS & TRANSACTIONS ========================

// Load bank statements
export const loadBankStatements = async (organization, page = 1, pageSize = 100) => {
  try {
    const response = await axios.get(`/accounting/bank-statement/`, {
      params: {
        organization,
        page,
        page_size: pageSize,
      }
    });
    return response.data;
  } catch (err) {
    console.log("Error loading bank statements:", err);
    notify("error", "Failed to load bank statements");
    return null;
  }
};

// Load bank transactions with filters
export const loadBankTransactions = async (params) => {
  try {
    const response = await axios.get(`/accounting/bank-transaction/`, { params });
    return response.data;
  } catch (err) {
    console.log("Error loading bank transactions:", err);
    notify("error", "Failed to load bank transactions");
    return null;
  }
};

// ======================== LINKS ========================

// Link Categories
export const loadLinkCategories = async (page, searchValue, page_size) => {
  try {
    if (!page) page = 1;
    if (!page_size) page_size = 15;
    let url = `/links/categories/?page=${page}&page_size=${page_size}`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading link categories:", err);
    return err;
  }
};

export const loadAllLinkCategories = async () => {
  try {
    const response = await axios.get(`/links/categories/?page_size=1000`);
    return response.data?.results || response.data || [];
  } catch (err) {
    console.log("Error loading all link categories:", err);
    return [];
  }
};

export const fetchLinkCategory = async (id) => {
  try {
    const response = await axios.get(`/links/categories/${id}/`);
    return response.data;
  } catch (err) {
    console.log("Error fetching link category:", err);
    return err;
  }
};

export const addLinkCategory = async (data) => {
  try {
    const response = await axios.post(`/links/categories/`, data);
    notify("success", "Link category created successfully!");
    return response.data;
  } catch (err) {
    console.log("Error adding link category:", err);
    notify("error", "Failed to create link category");
    throw err;
  }
};

export const updateLinkCategory = async (data, id) => {
  try {
    const response = await axios.put(`/links/categories/${id}/`, data);
    notify("success", "Link category updated successfully!");
    return response.data;
  } catch (err) {
    console.log("Error updating link category:", err);
    notify("error", "Failed to update link category");
    throw err;
  }
};

export const deleteLinkCategory = async (id) => {
  try {
    const response = await axios.delete(`/links/categories/${id}/`);
    notify("success", "Link category deleted successfully!");
    return response;
  } catch (err) {
    console.log("Error deleting link category:", err);
    notify("error", "Failed to delete link category");
    return err;
  }
};

// Links
export const loadLinks = async (page, searchValue, page_size) => {
  try {
    if (!page) page = 1;
    if (!page_size) page_size = 15;
    let url = `/links/links/?page=${page}&page_size=${page_size}`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading links:", err);
    return err;
  }
};

// `filters`: { status, link_type, category } - blanks are ignored.
export const loadAllLinks = async (searchValue, filters = {}) => {
  try {
    let url = `/links/links/?page_size=1000`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    ["status", "link_type", "category"].forEach((key) => {
      if (filters[key]) url += `&${key}=${encodeURIComponent(filters[key])}`;
    });
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error loading all links:", err);
    return err;
  }
};

export const loadMySharedLinks = async () => {
  try {
    const response = await axios.get(`/links/links/my-links/`);
    return response;
  } catch (err) {
    console.log("Error loading shared links:", err);
    return err;
  }
};

export const fetchLink = async (id) => {
  try {
    const response = await axios.get(`/links/links/${id}/`);
    return response.data;
  } catch (err) {
    console.log("Error fetching link:", err);
    return err;
  }
};

export const addLink = async (data) => {
  try {
    const response = await axios.post(`/links/links/`, data);
    notify("success", "Link created successfully!");
    return response.data;
  } catch (err) {
    console.log("Error adding link:", err);
    notify("error", "Failed to create link");
    throw err;
  }
};

export const updateLink = async (data, id) => {
  try {
    const response = await axios.put(`/links/links/${id}/`, data);
    notify("success", "Link updated successfully!");
    return response.data;
  } catch (err) {
    console.log("Error updating link:", err);
    notify("error", "Failed to update link");
    throw err;
  }
};

export const deleteLink = async (id) => {
  try {
    const response = await axios.delete(`/links/links/${id}/`);
    notify("success", "Link deleted successfully!");
    return response;
  } catch (err) {
    console.log("Error deleting link:", err);
    notify("error", "Failed to delete link");
    return err;
  }
};

export const recordLinkClick = async (id) => {
  try {
    const response = await axios.post(`/links/links/${id}/record_click/`);
    return response.data;
  } catch (err) {
    console.log("Error recording link click:", err);
    return err;
  }
};

export const verifyLink = async (id) => {
  try {
    const response = await axios.post(`/links/links/${id}/verify/`);
    notify("success", "Link verified successfully!");
    return response.data;
  } catch (err) {
    console.log("Error verifying link:", err);
    notify("error", "Failed to verify link");
    return err;
  }
};

export const markLinkBroken = async (id) => {
  try {
    const response = await axios.post(`/links/links/${id}/mark_broken/`);
    notify("warning", "Link marked as broken");
    return response.data;
  } catch (err) {
    console.log("Error marking link as broken:", err);
    notify("error", "Failed to mark link as broken");
    return err;
  }
};

export const getLinkVersions = async (linkId) => {
  try {
    const response = await axios.get(`/links/links/${linkId}/versions/`);
    return response.data;
  } catch (err) {
    console.log("Error getting link versions:", err);
    return [];
  }
};

export const restoreLinkVersion = async (linkId, versionId) => {
  try {
    const response = await axios.post(`/links/links/${linkId}/restore-version/${versionId}/`);
    notify("success", "Link restored to previous version!");
    return response.data;
  } catch (err) {
    console.log("Error restoring link version:", err);
    notify("error", "Failed to restore link version");
    throw err;
  }
};

export const getLinkAnalytics = async (linkId) => {
  try {
    const response = await axios.get(`/links/links/${linkId}/analytics/`);
    return response.data;
  } catch (err) {
    console.log("Error getting link analytics:", err);
    return null;
  }
};

// Link Tags
export const loadLinkTags = async () => {
  try {
    const response = await axios.get(`/links/tags/?page_size=1000`);
    return response.data?.results || response.data || [];
  } catch (err) {
    console.log("Error loading link tags:", err);
    return [];
  }
};

export const addLinkTag = async (data) => {
  try {
    const response = await axios.post(`/links/tags/`, data);
    notify("success", "Tag created successfully!");
    return response.data;
  } catch (err) {
    console.log("Error adding link tag:", err);
    notify("error", "Failed to create tag");
    throw err;
  }
};

export const deleteLinkTag = async (id) => {
  try {
    const response = await axios.delete(`/links/tags/${id}/`);
    notify("success", "Tag deleted successfully!");
    return response;
  } catch (err) {
    console.log("Error deleting link tag:", err);
    notify("error", "Failed to delete tag");
    return err;
  }
};

// ===================== Events & Meetings =====================

export const loadEvents = async (page, searchValue, page_size) => {
  try {
    if (!page) page = 1;
    if (!page_size) page_size = 15;
    let url = `/events/events/?page=${page}&page_size=${page_size}`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    return err;
  }
};

export const loadMyEvents = async (page, searchValue, page_size) => {
  try {
    if (!page) page = 1;
    if (!page_size) page_size = 15;
    let url = `/events/events/my-events/?page=${page}&page_size=${page_size}`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    return err;
  }
};

export const fetchEvent = async (id) => {
  try {
    const response = await axios.get(`/events/events/${id}/`);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const createEvent = async (data) => {
  try {
    const response = await axios.post(`/events/events/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateEvent = async (data, id) => {
  try {
    const response = await axios.put(`/events/events/${id}/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteEvent = async (id) => {
  try {
    const response = await axios.delete(`/events/events/${id}/`);
    return response;
  } catch (err) {
    return err;
  }
};

// Outlook Calendar Sync
export const getOutlookSyncs = async () => {
  try {
    const response = await axios.get(`/events/outlook-syncs/`);
    return response.data;
  } catch (err) {
    return err;
  }
};

export const createOutlookSync = async (data) => {
  try {
    const response = await axios.post(`/events/outlook-syncs/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteOutlookSync = async (id) => {
  try {
    const response = await axios.delete(`/events/outlook-syncs/${id}/`);
    return response;
  } catch (err) {
    return err;
  }
};

export const triggerOutlookSync = async (id) => {
  try {
    const response = await axios.post(`/events/outlook-syncs/${id}/sync-now/`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

////////////////////////// LEAVE MANAGEMENT //////////////////////////

export const loadLeaveApplications = async (page, searchValue, pageSize, employeeId) => {
  try {
    let url = `leave-management/leave-applications/?page=${page || 1}&page_size=${pageSize || 15}`;
    if (searchValue) url += `&search=${encodeURIComponent(searchValue)}`;
    if (employeeId) url += `&employee=${employeeId}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const createLeaveApplication = async (data) => {
  try {
    const response = await axios.post(`/leave-management/leave-applications/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateLeaveApplication = async (id, data) => {
  try {
    const response = await axios.put(`/leave-management/leave-applications/${id}/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const approveLeaveApplication = async (id, reason) => {
  try {
    const response = await axios.post(`/leave-management/leave-applications/${id}/approve/`, { reason: reason || '' });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const rejectLeaveApplication = async (id, reason) => {
  try {
    const response = await axios.post(`/leave-management/leave-applications/${id}/reject/`, { reason });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const generateLeaveCredits = async (year, month) => {
  try {
    const response = await axios.post(`/leave-management/leave-balances/generate-credits/`, {
      year,
      month,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const loadLeaveBalances = async (page, pageSize, year, employeeId) => {
  try {
    let url = `leave-management/leave-balances/?page=${page || 1}&page_size=${pageSize || 100}`;
    if (year) url += `&year=${year}`;
    if (employeeId) url += `&employee=${employeeId}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadMyLeaveBalances = async (year) => {
  try {
    let url = `leave-management/leave-balances/my-balances/`;
    if (year) url += `?year=${year}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadLMHolidays = async (page, pageSize, params) => {
  try {
    let url = `leave-management/holidays/?page=${page || 1}&page_size=${pageSize || 100}`;
    if (params?.year) url += `&year=${params.year}`;
    if (params?.search) url += `&search=${params.search}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const createLMHoliday = async (data) => {
  try {
    const response = await axios.post(`/leave-management/holidays/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateLMHoliday = async (id, data) => {
  try {
    const response = await axios.put(`/leave-management/holidays/${id}/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteLMHoliday = async (id) => {
  try {
    await axios.delete(`/leave-management/holidays/${id}/`);
    return true;
  } catch (err) {
    throw err;
  }
};

export const expandHolidays = async (year) => {
  try {
    const response = await axios.post(`/leave-management/holidays/expand/`, {
      year,
    });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createLeaveType = async (data) => {
  try {
    const response = await axios.post(`/leave-management/leave-types/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateLeaveType = async (id, data) => {
  try {
    const response = await axios.put(`/leave-management/leave-types/${id}/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteLeaveType = async (id) => {
  try {
    await axios.delete(`/leave-management/leave-types/${id}/`);
    return true;
  } catch (err) {
    throw err;
  }
};

export const loadLeaveEncashments = async (page, pageSize) => {
  try {
    let url = `leave-management/leave-encashments/?page=${page || 1}&page_size=${pageSize || 15}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const createLeaveEncashment = async (data) => {
  try {
    const response = await axios.post(`/leave-management/leave-encashments/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const approveLeaveEncashment = async (id) => {
  try {
    const response = await axios.post(`/leave-management/leave-encashments/${id}/approve/`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const rejectLeaveEncashment = async (id, reason) => {
  try {
    const response = await axios.post(`/leave-management/leave-encashments/${id}/reject/`, { reason });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const loadLeaveCreditLogs = async (page, pageSize, params = {}) => {
  try {
    let url = `leave-management/credit-logs/?page=${page || 1}&page_size=${pageSize || 15}`;
    if (params.year) url += `&year=${params.year}`;
    if (params.month) url += `&month=${params.month}`;
    if (params.employee) url += `&employee=${params.employee}`;
    if (params.leave_type) url += `&leave_type=${params.leave_type}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

////////////////////////// WORK FROM HOME //////////////////////////

export const loadWFHRequests = async (page, pageSize, params = {}) => {
  try {
    let url = `work-from-home/requests/?page=${page || 1}&page_size=${pageSize || 15}`;
    if (params.search) url += `&search=${params.search}`;
    if (params.status) url += `&status=${params.status}`;
    if (params.employee) url += `&employee=${params.employee}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const createWFHRequest = async (data) => {
  try {
    const response = await axios.post(`/work-from-home/requests/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const updateWFHRequest = async (id, data) => {
  try {
    const response = await axios.put(`/work-from-home/requests/${id}/`, data);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const deleteWFHRequest = async (id) => {
  try {
    const response = await axios.delete(`/work-from-home/requests/${id}/`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const approveWFHRequest = async (id) => {
  try {
    const response = await axios.post(`/work-from-home/requests/${id}/approve/`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const rejectWFHRequest = async (id, reason) => {
  try {
    const response = await axios.post(`/work-from-home/requests/${id}/reject/`, { reason });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const loadWFHBalances = async (page, pageSize, year, employeeId) => {
  try {
    let url = `work-from-home/balances/?page=${page || 1}&page_size=${pageSize || 100}`;
    if (year) url += `&year=${year}`;
    if (employeeId) url += `&employee=${employeeId}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadMyWFHBalance = async (year) => {
  try {
    let url = `/work-from-home/balances/my-balance/`;
    if (year) url += `?year=${year}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return null;
  }
};

export const loadMyCompOffBalance = async (year) => {
  try {
    let url = `/attendance/comp-off-balances/my-balance/`;
    if (year) url += `?year=${year}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return null;
  }
};

export const loadCompOffBalances = async (employeeId) => {
  try {
    let url = `/attendance/comp-off-balances/?page_size=100`;
    if (employeeId) url += `&employee=${employeeId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return null;
  }
};

export const generateWFHCredits = async (year, month) => {
  try {
    const response = await axios.post(`/work-from-home/balances/generate-credits/`, { year, month });
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const loadWFHCreditLogs = async (page, pageSize, params = {}) => {
  try {
    let url = `work-from-home/credit-logs/?page=${page || 1}&page_size=${pageSize || 15}`;
    if (params.year) url += `&year=${params.year}`;
    if (params.month) url += `&month=${params.month}`;
    if (params.employee) url += `&employee=${params.employee}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const loadLeavePolicies = async (page, pageSize) => {
  try {
    let url = `leave-management/leave-policies/?page=${page || 1}&page_size=${pageSize || 100}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// ===========================
// PAYMENT-FIRST INVOICE WORKFLOW
// ===========================

export const loadUnlinkedPayments = async (accountId) => {
  try {
    let url = `/invoices/payments/unlinked_payments/`;
    if (accountId) url += `?account_id=${accountId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    return [];
  }
};

export const linkPaymentToInvoice = async (paymentId, invoiceId) => {
  try {
    const response = await axios.post(`/invoices/payments/${paymentId}/link_invoice/`, {
      invoice_id: invoiceId,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// ===========================
// PRODUCT PAYMENT PRODUCTS
// ===========================

export const loadProductPaymentProducts = async () => {
  try {
    const response = await axios.get(`/payment/pr/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

// ===========================
// SUBSCRIPTIONS
// ===========================

export const loadSubscriptionPlans = async (page, pageSize) => {
  try {
    let url = `/payment/subscription-plans/?page=${page || 1}&page_size=${pageSize || 100}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const addSubscriptionPlan = async (data) => {
  try {
    const response = await axios.post(`/payment/subscription-plans/`, data);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const updateSubscriptionPlan = async (id, data) => {
  try {
    const response = await axios.patch(`/payment/subscription-plans/${id}/`, data);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const deleteSubscriptionPlan = async (id) => {
  try {
    const response = await axios.delete(`/payment/subscription-plans/${id}/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const syncPlanToRazorpay = async (id) => {
  try {
    const response = await axios.post(`/payment/subscription-plans/${id}/sync_to_razorpay/`);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadSubscriptions = async (page, pageSize, params = {}) => {
  try {
    let url = `/payment/subscriptions/?page=${page || 1}&page_size=${pageSize || 100}`;
    if (params.product) url += `&product=${params.product}`;
    if (params.status) url += `&status=${params.status}`;
    const response = await axios.get(url);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const cancelSubscription = async (id, cancelAtCycleEnd = true) => {
  try {
    const response = await axios.post(`/payment/subscriptions/${id}/cancel/`, {
      cancel_at_cycle_end: cancelAtCycleEnd,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const syncSubscriptionStatus = async (id) => {
  try {
    const response = await axios.post(`/payment/subscriptions/${id}/sync_status/`);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const createSubscription = async (data) => {
  try {
    const response = await axios.post(`/payment/subscriptions/`, data);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const generatePaymentLink = async (id) => {
  try {
    const response = await axios.post(`/payment/subscriptions/${id}/generate_payment_link/`);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const confirmManualPayment = async (id, action, notes = "") => {
  try {
    const response = await axios.post(`/payment/subscriptions/${id}/confirm_manual_payment/`, {
      action,
      notes,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const bulkPushPlans = async (gateway, password) => {
  try {
    const response = await axios.post(`/payment/subscription-plans/bulk_push/`, {
      gateway,
      password,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const bulkPullPlans = async (gateway, password, productId) => {
  try {
    const response = await axios.post(`/payment/subscription-plans/bulk_pull/`, {
      gateway,
      password,
      product_id: productId,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadPlanSyncHistory = async (direction) => {
  try {
    let url = `/payment/subscription-plans/sync_history/`;
    if (direction) url += `?direction=${direction}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// ===== Subscription Bulk Sync =====
export const bulkPushSubscriptions = async (gateway, password, productId) => {
  try {
    const response = await axios.post(`/payment/subscriptions/bulk_push/`, {
      gateway,
      password,
      product_id: productId,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const bulkPullSubscriptions = async (gateway, password, productId) => {
  try {
    const response = await axios.post(`/payment/subscriptions/bulk_pull/`, {
      gateway,
      password,
      product_id: productId,
    });
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadSubscriptionSyncHistory = async (direction) => {
  try {
    let url = `/payment/subscriptions/sync_history/`;
    if (direction) url += `?direction=${direction}`;
    const response = await axios.get(url);
    return response.data;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// ==================== Standalone Payment Links ====================

export const createPaymentLink = async (data) => {
  try {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const config = isFormData
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : undefined;
    const response = await axios.post(`/invoices/payment-links/`, data, config);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadPaymentLinks = async (search = "", page = 1, pageSize = 50) => {
  try {
    const response = await axios.get(`/invoices/payment-links/`, {
      params: { search, page, page_size: pageSize },
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadPaymentLink = async (id) => {
  try {
    const response = await axios.get(`/invoices/payment-links/${id}/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const confirmPaymentLinkManualPayment = async (id, action, notes = "") => {
  try {
    const response = await axios.post(`/invoices/payment-links/${id}/confirm_manual_payment/`, {
      action,
      notes,
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const approvePaymentLink = async (id, notes = "") => {
  try {
    const response = await axios.post(`/invoices/payment-links/${id}/approve_payment/`, {
      notes,
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const cancelPaymentLink = async (id) => {
  try {
    const response = await axios.post(`/invoices/payment-links/${id}/cancel/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const updatePaymentLink = async (id, data) => {
  try {
    const isFormData = typeof FormData !== "undefined" && data instanceof FormData;
    const config = isFormData
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : undefined;
    const response = await axios.patch(`/invoices/payment-links/${id}/`, data, config);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadOrgSMTPConfigs = async () => {
  try {
    const response = await axios.get(`/organization/orgsmtp/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const loadPaymentProducts = async () => {
  try {
    const response = await axios.get(`/payment/products/`, {
      params: { page_size: 200 },
    });
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const confirmPaymentLinkProof = async (linkId, proofId, action, notes = "") => {
  try {
    const response = await axios.post(
      `/invoices/payment-links/${linkId}/confirm-proof/${proofId}/`,
      { action, notes }
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const attachPaymentToLink = async (linkId, paymentId) => {
  try {
    const response = await axios.post(
      `/invoices/payment-links/${linkId}/attach_payment/`,
      { payment_id: paymentId }
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const resendPaymentLinkEmail = async (linkId, proofId = null) => {
  try {
    const response = await axios.post(
      `/invoices/payment-links/${linkId}/resend_confirmation_email/`,
      proofId ? { proof_id: proofId } : {}
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const updatePaymentLinkProof = async (linkId, proofId, data) => {
  try {
    const response = await axios.post(
      `/invoices/payment-links/${linkId}/update-proof/${proofId}/`,
      data
    );
    return response;
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

// ============ Notifications ============
export const getUnreadNotificationCount = async () => {
  const response = await axios.get('/notifications/unread-count/');
  return response.data;
};

export const getNotifications = async (page = 1, pageSize = 10) => {
  const response = await axios.get('/notifications/', {
    params: { page, page_size: pageSize }
  });
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await axios.post(`/notifications/${id}/read/`);
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await axios.post('/notifications/mark-all-read/');
  return response.data;
};

////////////////////////// EMAIL BROADCASTS - Actions //////////////////////////

export const loadEmailTemplates = async (page = 1) => {
  try {
    const response = await axios.get(`/emails/templates/?page=${page}&page_size=100`);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to load email templates");
    return err;
  }
};

export const createEmailTemplate = async (data) => {
  try {
    const response = await axios.post(`/emails/templates/`, data);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to create email template");
    return err;
  }
};

export const updateEmailTemplate = async (id, data) => {
  try {
    const response = await axios.put(`/emails/templates/${id}/`, data);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to update email template");
    return err;
  }
};

export const deleteEmailTemplate = async (id) => {
  try {
    await axios.delete(`/emails/templates/${id}/`);
    notify("success", "Email template deleted");
    return true;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to delete email template");
    return err;
  }
};

export const loadEmailBroadcasts = async (page = 1) => {
  try {
    const response = await axios.get(`/emails/broadcasts/?page=${page}&page_size=100`);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to load email broadcasts");
    return err;
  }
};

export const createEmailBroadcast = async (data) => {
  try {
    const response = await axios.post(`/emails/broadcasts/`, data);
    return response;
  } catch (err) {
    console.log("Error", err);
    notify("error", "Failed to create email broadcast");
    return err;
  }
};

export const sendEmailBroadcast = async (id) => {
  try {
    const response = await axios.post(`/emails/broadcasts/${id}/send/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const getEmailBroadcastProgress = async (id) => {
  try {
    const response = await axios.get(`/emails/broadcasts/${id}/progress/`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const getEmailBroadcastRecipients = async (id, page = 1) => {
  try {
    const response = await axios.get(`/emails/broadcasts/${id}/recipients/?page=${page}&page_size=500`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};

export const getCampaignRecipientCount = async (campaignId) => {
  try {
    const response = await axios.get(`/emails/broadcasts/campaign_recipients/?campaign=${campaignId}`);
    return response;
  } catch (err) {
    console.log("Error", err);
    return err;
  }
};
